import { PLATFORM_ADMIN_ROLE_NAMES as e } from "@teletienda/shared-utils-lib";
import { create as t } from "zustand";
import { createJSONStorage as n, persist as r } from "zustand/middleware";
import i, { HTTPError as a } from "ky";
import { createContext as o, useCallback as s, useContext as c, useEffect as l, useMemo as u, useRef as d, useState as f } from "react";
import { Alert as p, Anchor as m, Avatar as h, Box as g, Button as _, Center as v, Checkbox as y, Code as b, Divider as x, Group as S, Loader as C, Menu as w, Modal as T, Paper as E, PasswordInput as D, Progress as O, SegmentedControl as k, Stack as A, Text as j, TextInput as M, ThemeIcon as N, Title as P, UnstyledButton as F, useComputedColorScheme as ee, useMantineTheme as te } from "@mantine/core";
import { useForm as ne } from "@mantine/form";
import { IconAlertCircle as I, IconArrowLeft as re, IconBrandFacebook as ie, IconBrandGoogle as ae, IconBrandWhatsapp as oe, IconCheck as se, IconChevronDown as ce, IconHome as le, IconInfoCircle as ue, IconLock as de, IconLogout as fe, IconMail as pe, IconShieldCheck as me, IconShoppingCart as he, IconUser as ge, IconWallet as _e, IconX as ve } from "@tabler/icons-react";
import { z as L } from "zod";
import { useTranslation as R } from "react-i18next";
import { Fragment as z, jsx as B, jsxs as V } from "react/jsx-runtime";
import { useDisclosure as ye, useMediaQuery as be } from "@mantine/hooks";
import { notifications as xe } from "@mantine/notifications";
//#region src/utils/storage/config.ts
var Se = "teletienda-auth", Ce = "teletienda-auth-sync", we = "tt-auth-sync", Te = 2e3, Ee = 720 * 60 * 60, De = ".teletienda.ar", Oe = null;
function ke() {
	return typeof window > "u" ? !1 : window.location.hostname.endsWith(".teletienda.ar");
}
function Ae() {
	if (typeof window > "u") return "localhost";
	let e = window.location.hostname;
	return e.endsWith(".teletienda.ar") ? De : e.endsWith(".teletienda.local") ? ".teletienda.local" : e;
}
function je() {
	let e = ke() || typeof window < "u" && window.location.protocol === "https:";
	return {
		cookieDomain: Ae(),
		secure: e,
		sameSite: "lax",
		maxAge: Ee,
		storageKey: Se
	};
}
function H() {
	return Oe ||= je(), Oe;
}
function Me(e) {
	Oe = {
		...je(),
		...e
	};
}
function Ne() {
	Oe = null;
}
//#endregion
//#region src/utils/storage/cookies.ts
function Pe() {
	let e = /* @__PURE__ */ new Map();
	if (typeof document > "u") return e;
	let t = document.cookie.split(";");
	for (let n of t) {
		let [t, ...r] = n.split("=");
		if (t) {
			let n = t.trim(), i = r.join("=").trim();
			if (n) try {
				e.set(n, decodeURIComponent(i));
			} catch {
				e.set(n, i);
			}
		}
	}
	return e;
}
function Fe(e) {
	return Pe().get(e) ?? null;
}
function Ie(e, t, n) {
	if (typeof document > "u") return;
	let r = H(), i = {
		domain: n?.domain ?? r.cookieDomain,
		path: n?.path ?? "/",
		maxAge: n?.maxAge ?? r.maxAge,
		secure: n?.secure ?? r.secure,
		sameSite: n?.sameSite ?? r.sameSite
	}, a = [
		`${encodeURIComponent(e)}=${encodeURIComponent(t)}`,
		`path=${i.path}`,
		`max-age=${i.maxAge}`,
		`samesite=${i.sameSite}`
	];
	i.domain && i.domain !== "localhost" && a.push(`domain=${i.domain}`), i.secure && a.push("secure"), document.cookie = a.join("; ");
}
function Le(e, t) {
	if (typeof document > "u") return;
	let n = H(), r = t ?? n.cookieDomain, i = [
		`${encodeURIComponent(e)}=`,
		"path=/",
		"max-age=0",
		"expires=Thu, 01 Jan 1970 00:00:00 GMT"
	];
	r && r !== "localhost" && i.push(`domain=${r}`), document.cookie = i.join("; ");
}
function Re() {
	if (typeof document > "u") return !1;
	try {
		let e = "__tt_cookie_test__";
		document.cookie = `${e}=1; path=/`;
		let t = document.cookie.includes(e);
		return document.cookie = `${e}=; path=/; max-age=0`, t;
	} catch {
		return !1;
	}
}
function ze(e, t, n) {
	Ie(e, JSON.stringify(t), n);
}
function Be(e) {
	let t = Fe(e);
	if (!t) return null;
	try {
		return JSON.parse(t);
	} catch {
		return null;
	}
}
//#endregion
//#region src/utils/storage/crossTabSync.ts
var Ve = class {
	channel = null;
	handlers = /* @__PURE__ */ new Set();
	useFallback = !1;
	boundStorageHandler = null;
	constructor() {
		this.init();
	}
	init() {
		if (!(typeof window > "u")) {
			if ("BroadcastChannel" in window) try {
				this.channel = new BroadcastChannel(Ce), this.channel.onmessage = (e) => {
					this.notifyHandlers(e.data);
				};
				return;
			} catch {}
			this.useFallback = !0, this.boundStorageHandler = this.handleStorageEvent.bind(this), window.addEventListener("storage", this.boundStorageHandler);
		}
	}
	handleStorageEvent(e) {
		if (e.key === "teletienda-auth-sync" && e.newValue) try {
			let t = JSON.parse(e.newValue);
			this.notifyHandlers(t);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Sync handler error:", e);
		}
	}
	subscribe(e) {
		return this.handlers.add(e), () => {
			this.handlers.delete(e);
		};
	}
	broadcast(e, t) {
		let n = {
			type: e,
			timestamp: Date.now(),
			data: t
		};
		if (this.channel) this.channel.postMessage(n);
		else if (this.useFallback && typeof localStorage < "u") try {
			localStorage.setItem(`${Se}-sync`, JSON.stringify(n)), localStorage.removeItem(`${Se}-sync`);
		} catch {}
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.channel &&= (this.channel.close(), null), this.boundStorageHandler && typeof window < "u" && (window.removeEventListener("storage", this.boundStorageHandler), this.boundStorageHandler = null), this.handlers.clear();
	}
	isUsingBroadcastChannel() {
		return this.channel !== null;
	}
}, He = null;
function Ue() {
	return He ||= new Ve(), He;
}
function We() {
	He &&= (He.destroy(), null);
}
function Ge(e) {
	return Ue().subscribe(e);
}
function Ke() {
	Ue().broadcastLogin();
}
function qe() {
	Ue().broadcastLogout();
}
function Je() {
	Ue().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/crossSubdomainSync.ts
var Ye = class {
	handlers = /* @__PURE__ */ new Set();
	pollInterval = null;
	lastSeenTimestamp = 0;
	currentOrigin = "";
	constructor() {
		typeof window < "u" && (this.currentOrigin = window.location.origin, this.initializeFromCookie());
	}
	initializeFromCookie() {}
	getPendingEvent() {
		let e = Fe(we);
		if (!e) return null;
		try {
			let t = JSON.parse(e);
			return t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp ? null : t;
		} catch {
			return null;
		}
	}
	startPolling() {
		this.pollInterval || typeof window > "u" || (this.pollInterval = setInterval(() => {
			this.checkForChanges();
		}, Te));
	}
	stopPolling() {
		this.pollInterval &&= (clearInterval(this.pollInterval), null);
	}
	checkForChanges() {
		let e = Fe(we);
		if (e) try {
			let t = JSON.parse(e);
			if (t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp) return;
			this.lastSeenTimestamp = t.timestamp;
			let n = {
				type: t.type,
				timestamp: t.timestamp
			};
			this.notifyHandlers(n);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Cross-subdomain sync handler error:", e);
		}
	}
	subscribe(e) {
		if (this.handlers.add(e), this.handlers.size === 1) {
			this.startPolling();
			let t = this.getPendingEvent();
			t && (this.lastSeenTimestamp = t.timestamp, setTimeout(() => {
				e({
					type: t.type,
					timestamp: t.timestamp
				});
			}, 0));
		}
		return () => {
			this.handlers.delete(e), this.handlers.size === 0 && this.stopPolling();
		};
	}
	broadcast(e) {
		if (typeof window > "u") return;
		let t = {
			type: e,
			timestamp: Date.now(),
			origin: this.currentOrigin
		};
		this.lastSeenTimestamp = t.timestamp, Ie(we, JSON.stringify(t), { maxAge: 300 });
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.stopPolling(), this.handlers.clear();
	}
	isPolling() {
		return this.pollInterval !== null;
	}
}, Xe = null;
function Ze() {
	return Xe ||= new Ye(), Xe;
}
function Qe() {
	Xe &&= (Xe.destroy(), null);
}
function $e(e) {
	return Ze().subscribe(e);
}
function et() {
	Ze().broadcastLogin();
}
function tt() {
	Ze().broadcastLogout();
}
function nt() {
	Ze().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/slimCookieStorage.ts
var rt = "tt-auth-slim", it = 3072, at = 4096;
function ot(e) {
	if (!e || typeof e != "object") return !1;
	let t = e;
	return typeof t.token == "string" && typeof t.refreshToken == "string" && typeof t.userGuid == "string" && typeof t.isAuthenticated == "boolean" && typeof t.expiresAt == "number";
}
function st(e) {
	return typeof Blob < "u" ? new Blob([e]).size : new TextEncoder().encode(e).length;
}
function ct() {
	let e = Fe(rt), t = e ? st(e) : 0;
	return {
		currentSize: t,
		maxSize: at,
		warningThreshold: it,
		isOverWarning: t > it,
		isOverLimit: t > at,
		percentUsed: Math.round(t / at * 100)
	};
}
function lt(e) {
	let t = JSON.stringify(e), n = st(t);
	return n > 4096 ? (console.error(`[SlimCookie] Cookie size (${n} bytes) exceeds maximum (${at} bytes). Cookie will NOT be set to prevent silent browser rejection.`), !1) : (n > 3072 && console.warn(`[SlimCookie] Cookie size (${n} bytes) exceeds warning threshold (${it} bytes). Consider reducing stored data.`), Ie(rt, t), !0);
}
function U() {
	let e = Fe(rt);
	if (!e) return null;
	try {
		let t = JSON.parse(e);
		return ot(t) ? t : (console.warn("[SlimCookie] Cookie contains invalid SlimAuthData structure"), null);
	} catch (e) {
		return console.warn("[SlimCookie] Failed to parse cookie JSON:", e), null;
	}
}
function W() {
	Le(rt);
}
//#endregion
//#region src/api/config.ts
var G = { timeout: 3e4 }, ut = null;
function dt(e) {
	return e && e.length > 0 ? e : (console.error("[shared-auth-ui] baseUrl is not declared: pass apiBaseUrl / configureAuthApi({baseUrl}). Falling back to \"/\" — on a merchant app this is the WRONG service."), "/");
}
function ft(e) {
	G = {
		...G,
		...e
	}, ut = i.create({
		prefixUrl: dt(G.baseUrl),
		timeout: G.timeout,
		hooks: { beforeRequest: [(e) => {
			if (G.getToken) {
				let t = G.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	});
}
function K() {
	return ut ||= i.create({
		prefixUrl: dt(G.baseUrl),
		timeout: G.timeout,
		hooks: { beforeRequest: [(e) => {
			if (G.getToken) {
				let t = G.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	}), ut;
}
function pt() {
	return { ...G };
}
function mt(e) {
	G.getToken = e;
}
//#endregion
//#region src/utils/transformApiUser.ts
function q(e) {
	return {
		userGuid: e.user_guid,
		email: e.email || e.notification_email || e.notificationEmail,
		name: e.display_name || e.first_name || e.email?.split("@")[0] || "",
		firstName: e.first_name,
		lastName: e.last_name,
		phone: e.phone,
		avatarUrl: e.avatar || e.avatar_url,
		roles: e.roles || [],
		permissions: e.permissions || [],
		merchantGuid: e.merchant_guid,
		merchantGuids: e.merchant_guids,
		preferred_currency: e.preferred_currency,
		languageCode: e.language_code
	};
}
//#endregion
//#region src/utils/storage/authStorage.ts
function ht() {
	let e = {
		localStorage: !1,
		cookies: !1,
		broadcastChannel: !1,
		slimCookieSize: 0,
		slimCookieHealthy: !0
	};
	if (typeof window < "u" && window.localStorage) try {
		let t = "__tt_storage_test__";
		localStorage.setItem(t, "1"), localStorage.removeItem(t), e.localStorage = !0;
	} catch {}
	e.cookies = Re(), typeof window < "u" && "BroadcastChannel" in window && (e.broadcastChannel = !0);
	let t = ct();
	return e.slimCookieSize = t.currentSize, e.slimCookieHealthy = !t.isOverWarning, e;
}
function gt() {
	if (typeof window > "u") return !1;
	try {
		let e = "__tt_private_test__";
		return localStorage.setItem(e, "1"), localStorage.removeItem(e), "storage" in navigator && "estimate" in navigator.storage, !1;
	} catch {
		return !0;
	}
}
function _t(e) {
	let t = H();
	return e === t.storageKey || e.startsWith(t.storageKey) ? e : `${t.storageKey}-${e}`;
}
async function vt(e) {
	try {
		let t = await K().get("api/v1/users/me", { headers: { Authorization: `Bearer ${e}` } }).json();
		return t.success && t.data ? {
			status: "ok",
			user: q(t.data)
		} : (console.warn("[AuthStorage] hydrateFromApi: Invalid response format"), { status: "error" });
	} catch (e) {
		return e instanceof Error && e.message.includes("401") ? { status: "unauthorized" } : (console.warn("[AuthStorage] hydrateFromApi failed:", e), { status: "error" });
	}
}
function yt(e) {
	if (!e || typeof e != "object") return !1;
	let t = e.user;
	return t ? Array.isArray(t.roles) && Array.isArray(t.permissions) && typeof t.email == "string" : !1;
}
function bt() {
	let e = _t(H().storageKey);
	if (typeof window < "u" && window.localStorage) try {
		let t = localStorage.getItem(e);
		if (t && yt(JSON.parse(t)?.state)) return !1;
	} catch {}
	let t = U();
	return t !== null && t.isAuthenticated;
}
var xt = class {
	cookiesAvailable;
	localStorageAvailable;
	constructor() {
		let e = ht();
		this.cookiesAvailable = e.cookies, this.localStorageAvailable = e.localStorage, !this.localStorageAvailable && !this.cookiesAvailable ? console.warn("[shared-auth-ui] No storage available. Auth state will not persist.") : this.cookiesAvailable || console.warn("[shared-auth-ui] Cookies disabled. Cross-subdomain SSO will not work.");
	}
	getItem(e) {
		let t = _t(e), n = null;
		if (this.localStorageAvailable) try {
			n = localStorage.getItem(t);
		} catch {}
		if (n !== null) try {
			if (JSON.parse(n)?.state?.isAuthenticated === !0) return n;
		} catch {}
		if (this.cookiesAvailable) {
			let e = U();
			if (e && e.isAuthenticated) try {
				if ((n ? JSON.parse(n) : null)?.state?.isAuthenticated !== !0) {
					let t = {
						state: {
							user: { userGuid: e.userGuid },
							token: e.token,
							refreshToken: e.refreshToken,
							expiresAt: e.expiresAt,
							isAuthenticated: !0,
							isLoading: !1,
							_needsHydration: !0
						},
						version: 0
					};
					return JSON.stringify(t);
				}
			} catch {
				let t = {
					state: {
						user: { userGuid: e.userGuid },
						token: e.token,
						refreshToken: e.refreshToken,
						expiresAt: e.expiresAt,
						isAuthenticated: !0,
						isLoading: !1,
						_needsHydration: !0
					},
					version: 0
				};
				return JSON.stringify(t);
			}
			else if (e && !e.isAuthenticated && n) try {
				if (JSON.parse(n)?.state?.isAuthenticated === !0) {
					let e = {
						state: {
							user: null,
							token: null,
							refreshToken: null,
							expiresAt: null,
							isAuthenticated: !1,
							isLoading: !1
						},
						version: 0
					};
					if (this.localStorageAvailable) try {
						localStorage.setItem(t, JSON.stringify(e));
					} catch {}
					return JSON.stringify(e);
				}
			} catch {}
		}
		return n === null ? null : n;
	}
	setItem(e, t) {
		let n = _t(e);
		if (this.localStorageAvailable) try {
			localStorage.setItem(n, t);
		} catch (e) {
			if (this.isQuotaExceededError(e)) {
				this.handleQuotaExceeded();
				try {
					localStorage.setItem(n, t);
				} catch {}
			}
		}
		if (this.cookiesAvailable) try {
			let e = JSON.parse(t)?.state, n = e?.user?.userGuid;
			if (e?.token && n) {
				if (!e.expiresAt) return;
				lt({
					token: e.token,
					refreshToken: e.refreshToken || "",
					userGuid: n,
					isAuthenticated: e.isAuthenticated ?? !0,
					expiresAt: e.expiresAt
				});
			} else e?.isAuthenticated || W();
		} catch {}
	}
	removeItem(e) {
		let t = _t(e);
		if (this.localStorageAvailable) try {
			localStorage.removeItem(t);
		} catch {}
		this.cookiesAvailable && (Le(t), W());
	}
	clear() {
		let e = H();
		if (this.localStorageAvailable) try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
		this.cookiesAvailable && (Le(e.storageKey), Le(`${e.storageKey}-sync`), W()), qe();
	}
	isQuotaExceededError(e) {
		return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED");
	}
	handleQuotaExceeded() {
		console.warn("[shared-auth-ui] Storage quota exceeded. Clearing old data.");
		let e = H();
		try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && r !== e.storageKey && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
	}
	getHealth() {
		let e = ct();
		return {
			localStorage: this.localStorageAvailable,
			cookies: this.cookiesAvailable,
			broadcastChannel: typeof window < "u" && "BroadcastChannel" in window,
			slimCookieSize: e.currentSize,
			slimCookieHealthy: !e.isOverWarning
		};
	}
	notifyLogin() {
		Ke(), et();
	}
	notifyLogout() {
		qe(), tt();
	}
	notifyTokenRefresh() {
		Je(), nt();
	}
}, St = null;
function J() {
	return St ||= new xt(), St;
}
function Ct() {
	St = null;
}
function wt() {
	return J();
}
//#endregion
//#region src/store/authStore.ts
var Tt = Se, Y = {
	user: null,
	token: null,
	refreshToken: null,
	expiresAt: null,
	isAuthenticated: !1,
	isLoading: !1
}, Et = null;
function Dt(e) {
	Et = e;
}
function Ot() {
	return Et || wt();
}
var kt = (t, n) => ({
	...Y,
	login: (e, n, r, i) => {
		t({
			token: e,
			refreshToken: n,
			expiresAt: Date.now() + r * 1e3,
			user: i,
			isAuthenticated: !0,
			isLoading: !1
		}), J().notifyLogin();
	},
	logout: () => {
		t(Y), J().notifyLogout();
	},
	updateToken: (e, n, r) => {
		t({
			token: e,
			expiresAt: Date.now() + n * 1e3,
			...r && { refreshToken: r }
		}), J().notifyTokenRefresh();
	},
	updateUser: (e) => {
		t({ user: e });
	},
	setLoading: (e) => {
		t({ isLoading: e });
	},
	hasRole: (e) => {
		let { user: t } = n();
		return t ? t.roles.includes(e) : !1;
	},
	hasAnyRole: (e) => {
		let { user: t } = n();
		return t ? e.some((e) => t.roles.includes(e)) : !1;
	},
	hasPermission: (t) => {
		let { user: r } = n();
		return r ? e.some((e) => r.roles.includes(e)) ? !0 : r.permissions.includes(t) : !1;
	}
}), At = {
	name: Tt,
	storage: n(() => Ot()),
	partialize: (e) => ({
		user: e.user,
		token: e.token,
		refreshToken: e.refreshToken,
		expiresAt: e.expiresAt,
		isAuthenticated: e.isAuthenticated
	})
}, X = t()(r(kt, At)), jt = !1;
async function Mt(e, t = 3, n = !1) {
	for (let r = 0; r < t; r++) {
		if (await X.persist.rehydrate(), X.getState().isAuthenticated === e) return;
		!n && r < t - 1 && await new Promise((e) => setTimeout(e, 500 * 2 ** r));
	}
	console.warn("[shared-auth-ui] Rehydrate retry exhausted, state may be stale");
}
function Nt() {
	let e = U();
	if (!e?.isAuthenticated || !e?.token) return !1;
	let t = X.getState();
	return t.user?.userGuid && e.userGuid && t.user.userGuid !== e.userGuid ? (console.debug("[shared-auth-ui] UserGuid mismatch - forcing hydration"), !0) : !(t.isAuthenticated && t.user && Array.isArray(t.user.roles) && t.user.roles.length > 0);
}
async function Pt() {
	let e = U();
	if (!e?.token || !e?.isAuthenticated) return;
	let t = X.getState(), n = !t.user?.userGuid || t.user.userGuid === e.userGuid;
	if (!(t.isAuthenticated && t.user?.roles?.length && n)) {
		console.debug(n ? "[shared-auth-ui] Performing initial hydration from slim cookie" : "[shared-auth-ui] Performing initial hydration - userGuid mismatch detected"), X.setState({
			token: e.token,
			refreshToken: e.refreshToken,
			expiresAt: e.expiresAt,
			isAuthenticated: !0,
			isLoading: !0,
			user: null
		});
		try {
			let t = await vt(e.token);
			t.status === "ok" ? (X.setState({
				user: t.user,
				isLoading: !1
			}), console.debug("[shared-auth-ui] Initial hydration successful")) : t.status === "unauthorized" ? (X.setState(Y), W(), console.debug("[shared-auth-ui] Initial hydration failed - token rejected (401)")) : (X.setState(Y), console.debug("[shared-auth-ui] Initial hydration deferred - transient error, slim cookie preserved"));
		} catch (e) {
			console.warn("[shared-auth-ui] Initial hydration error:", e), X.setState(Y);
		}
	}
}
async function Ft() {
	Nt() && await Pt();
}
function It() {
	if (jt) return console.debug("[shared-auth-ui] Sync already initialized"), () => {};
	jt = !0, Nt() && Pt();
	let e = async (e) => {
		let t = X.getState();
		switch (e.type) {
			case "logout":
				t.isAuthenticated && X.setState(Y), W(), setTimeout(() => Mt(!1), 500);
				break;
			case "login": {
				let e = U();
				if (!e?.token || !e?.isAuthenticated) {
					console.debug("[shared-auth-ui] Cross-subdomain login: no slim cookie, retrying"), setTimeout(() => Mt(!0), 500);
					return;
				}
				console.debug("[shared-auth-ui] Cross-subdomain login: validating token before state update"), X.setState({ isLoading: !0 });
				try {
					let t = await vt(e.token);
					t.status === "ok" ? (console.debug("[shared-auth-ui] Cross-subdomain login: token validated, updating state"), X.setState({
						token: e.token,
						refreshToken: e.refreshToken,
						expiresAt: e.expiresAt,
						isAuthenticated: !0,
						isLoading: !1,
						user: t.user
					})) : t.status === "unauthorized" ? (console.warn("[shared-auth-ui] Cross-subdomain login: token rejected (401), clearing state"), X.setState(Y), W()) : (console.warn("[shared-auth-ui] Cross-subdomain login: transient error, slim cookie preserved"), X.setState({ isLoading: !1 }));
				} catch (e) {
					console.warn("[shared-auth-ui] Cross-subdomain login: API error", e), X.setState({ isLoading: !1 });
				}
				break;
			}
			case "token_refresh": {
				let e = U();
				e?.token && X.setState({
					token: e.token,
					expiresAt: e.expiresAt
				}), setTimeout(() => X.persist.rehydrate(), 500);
				break;
			}
		}
	}, t = Ge(e), n = $e(e);
	return () => {
		jt = !1, t(), n();
	};
}
function Lt() {
	let { expiresAt: e } = X.getState();
	return e ? Date.now() >= e - 120 * 1e3 : !1;
}
function Rt() {
	let { expiresAt: e } = X.getState();
	return e ? Date.now() >= e : !0;
}
function zt() {
	J().clear();
}
function Bt() {
	return J().getHealth();
}
//#endregion
//#region src/api/authApi.ts
var Z = class extends Error {
	code;
	status;
	details;
	constructor(e, t, n, r) {
		super(e), this.name = "AuthApiError", this.code = t, this.status = n, this.details = r;
	}
};
async function Vt(e) {
	if (e instanceof a) try {
		let t = await e.response.json();
		throw new Z(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
	} catch (t) {
		throw t instanceof Z ? t : new Z(e.message, "HTTP_ERROR", e.response.status);
	}
	throw e instanceof Error ? new Z(e.message, "NETWORK_ERROR", 0) : new Z("Unknown error", "UNKNOWN_ERROR", 0);
}
async function Ht(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/auth/login", { json: e }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Login failed", n.error?.code || "LOGIN_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Vt(e);
	}
}
async function Ut(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/auth/register", { json: e }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Registration failed", n.error?.code || "REGISTRATION_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Vt(e);
	}
}
async function Wt(e) {
	let t = K();
	try {
		let n = { refreshToken: e }, r = await t.post("api/v1/auth/refresh-token", { json: n }).json();
		if (!r.success || !r.data) throw new Z(r.error?.message || "Token refresh failed", r.error?.code || "REFRESH_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Vt(e);
	}
}
async function Gt(e) {
	let t = K();
	try {
		let n = { refreshToken: e };
		await t.post("api/v1/auth/logout", {
			json: n,
			timeout: 5e3
		});
	} catch {}
}
async function Kt(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/auth/request-login-code", { json: { email: e } }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Failed to request login code", n.error?.code || "REQUEST_CODE_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Vt(e);
	}
}
async function qt(e, t) {
	let n = K();
	try {
		let r = await n.post("api/v1/auth/login-by-code", { json: {
			email: e,
			code: t
		} }).json();
		if (!r.success || !r.data) throw new Z(r.error?.message || "Login by code failed", r.error?.code || "LOGIN_BY_CODE_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Vt(e);
	}
}
async function Jt(e) {
	let t = K();
	try {
		let n = await t.get("api/v1/users/me", {
			headers: { Authorization: `Bearer ${e}` },
			timeout: 1e4
		}).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Failed to fetch user profile", n.error?.code || "PROFILE_FETCH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Vt(e);
	}
}
//#endregion
//#region src/api/channelClaimApi.ts
async function Yt(e, t) {
	let n = await e;
	if (!n.success || !n.data) throw new Z(n.error?.message || "Channel claim failed", n.error?.code || t, 400, n.error?.details);
	return n.data;
}
async function Xt(e) {
	let t = K();
	try {
		return await Yt(t.post("api/v1/auth/channel-claim/start", { json: {
			merchant_guid: e,
			channel: "whatsapp"
		} }).json(), "CHANNEL_CLAIM_START_FAILED");
	} catch (e) {
		throw e instanceof Z ? e : new Z("Could not start WhatsApp login", "CHANNEL_CLAIM_START_FAILED", 503);
	}
}
async function Zt(e) {
	return Yt(K().get(`api/v1/auth/channel-claim/${encodeURIComponent(e)}`).json(), "CHANNEL_CLAIM_POLL_FAILED");
}
async function Qt(e) {
	return Yt(K().post(`api/v1/auth/channel-claim/${encodeURIComponent(e)}/accept`).json(), "CHANNEL_CLAIM_ACCEPT_FAILED");
}
//#endregion
//#region src/api/oauthApi.ts
async function $t(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/oauth/google/callback", { json: e }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Google OAuth failed", n.error?.code || "GOOGLE_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Google");
	}
}
async function en(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/oauth/google/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Google OIDC start failed", n.error?.code || "GOOGLE_OIDC_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Google");
	}
}
async function tn(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/auth/link/google/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Google OIDC link start failed", n.error?.code || "GOOGLE_OIDC_LINK_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Google");
	}
}
async function nn(e, t) {
	let n = K();
	try {
		let r = await n.post("api/v1/oauth/google/oidc/callback", { json: {
			code: e,
			state: t
		} }).json();
		if (!r.success || !r.data) throw new Z(r.error?.message || "Google OIDC callback failed", r.error?.code || "GOOGLE_OIDC_CALLBACK_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Google");
	}
}
async function rn(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/oauth/facebook/callback", { json: e }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Facebook OAuth failed", n.error?.code || "FACEBOOK_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Facebook");
	}
}
async function an(e) {
	let t = K();
	try {
		let n = await t.post("api/v1/oauth/telegram/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new Z(n.error?.message || "Telegram OIDC start failed", n.error?.code || "TELEGRAM_OIDC_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Telegram");
	}
}
async function on(e, t) {
	let n = K(), r = {};
	e && (r.returnUrl = e), t?.requestBotAccess && (r.requestBotAccess = !0);
	try {
		let e = await n.post("api/v1/auth/link/telegram/oidc/start", { json: r }).json();
		if (!e.success || !e.data) throw new Z(e.error?.message || "Telegram OIDC link start failed", e.error?.code || "TELEGRAM_OIDC_LINK_START_FAILED", 400, e.error?.details);
		return e.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Telegram");
	}
}
async function sn(e, t) {
	let n = K();
	try {
		let r = await n.post("api/v1/oauth/telegram/oidc/callback", { json: {
			code: e,
			state: t
		} }).json();
		if (!r.success || !r.data) throw new Z(r.error?.message || "Telegram OIDC callback failed", r.error?.code || "TELEGRAM_OIDC_CALLBACK_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof Z) throw e;
		return Q(e, "Telegram");
	}
}
async function Q(e, t) {
	let { HTTPError: n } = await import("ky");
	if (e instanceof n) try {
		let n = await e.response.json();
		throw new Z(n.error?.message || e.message, n.error?.code || `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status, n.error?.details);
	} catch (n) {
		throw n instanceof Z ? n : new Z(e.message, `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status);
	}
	throw e instanceof Error ? new Z(e.message, "NETWORK_ERROR", 0) : new Z("Unknown error", "UNKNOWN_ERROR", 0);
}
//#endregion
//#region src/api/httpClient.ts
var cn = null, ln = [];
function un() {
	cn = null, ln.length = 0;
}
async function dn(e) {
	if (cn) return cn;
	let t = X.getState(), n = t.refreshToken;
	if (!n) throw t.logout(), zt(), e?.(), new Z("No refresh token", "NO_REFRESH_TOKEN", 401);
	return cn = (async () => {
		try {
			let e = await Wt(n);
			t.updateToken(e.accessToken, e.expiresIn, e.refreshToken);
			let r = e.accessToken;
			return ln.forEach(({ resolve: e }) => e(r)), ln.length = 0, r;
		} catch (n) {
			throw ln.forEach(({ reject: e }) => e(n)), ln.length = 0, n instanceof Z && (n.status === 401 || n.status === 422) && (t.logout(), zt(), e?.()), n;
		} finally {
			cn = null;
		}
	})(), cn;
}
function fn() {
	return new Promise((e, t) => {
		ln.push({
			resolve: e,
			reject: t
		});
	});
}
function pn(e = {}) {
	let { baseUrl: t, timeout: n = 3e4, onSessionExpired: r } = e;
	return i.create({
		prefixUrl: t,
		timeout: n,
		hooks: {
			beforeRequest: [async (e) => {
				if (cn) try {
					let t = await fn();
					e.headers.set("Authorization", `Bearer ${t}`);
					return;
				} catch {}
				let t = X.getState().token;
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}],
			afterResponse: [async (e, t, n) => {
				if (n.status !== 401 || e.url.includes("/auth/refresh") || e.url.includes("/auth/login")) return n;
				try {
					let n = await dn(r), a = {
						...t,
						headers: {
							...Object.fromEntries(e.headers.entries()),
							Authorization: `Bearer ${n}`
						}
					};
					return i(e.url, a);
				} catch {
					return n;
				}
			}]
		}
	});
}
var mn = null, hn = {};
function gn(e) {
	hn = e, mn = pn(e);
}
function _n() {
	return mn ||= pn(hn), mn;
}
async function vn(e, t) {
	let n = _n();
	try {
		return await n(e, t).json();
	} catch (e) {
		if (e instanceof a) {
			let t = await e.response.json().catch(() => ({}));
			throw new Z(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
		}
		throw e;
	}
}
//#endregion
//#region src/hooks/useAuth.ts
function yn() {
	let e = X((e) => e.user), t = X((e) => e.token), n = X((e) => e.refreshToken), r = X((e) => e.isAuthenticated), i = X((e) => e.isLoading), a = X((e) => e.login), o = X((e) => e.logout), c = X((e) => e.updateToken), l = X((e) => e.updateUser), u = X((e) => e.setLoading), d = X((e) => e.hasRole), f = X((e) => e.hasAnyRole), p = X((e) => e.hasPermission);
	return {
		user: e,
		token: t,
		isAuthenticated: r,
		isLoading: i,
		loginWithCredentials: s(async (e) => {
			u(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await Ht(e), o = await Jt(t), s = q({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		loginByCode: s(async (e, t) => {
			u(!0);
			try {
				let { accessToken: n, refreshToken: r, expiresIn: i, user: o } = await qt(e, t), s = await Jt(n), c = q({
					...s,
					user_guid: s.user_guid || o.guid,
					email: s.email || o.email
				});
				return a(n, r, i, c), c;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		registerUser: s(async (e) => {
			u(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await Ut(e), o = await Jt(t), s = q({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		refreshToken: s(async () => {
			if (!n) throw o(), zt(), new Z("No refresh token available", "NO_REFRESH_TOKEN", 401);
			try {
				let e = await Wt(n);
				c(e.accessToken, e.expiresIn);
			} catch (e) {
				throw o(), zt(), e;
			}
		}, [
			n,
			o,
			c
		]),
		logout: s(async () => {
			n && Gt(n), o(), zt();
		}, [n, o]),
		fetchProfile: s(async (e) => {
			if (!t) throw new Z("Not authenticated", "NOT_AUTHENTICATED", 401);
			let n = e?.silent ?? !1;
			n || u(!0);
			try {
				let e = q(await Jt(t));
				return l(e), n || u(!1), e;
			} catch (e) {
				throw n || u(!1), e;
			}
		}, [
			t,
			u,
			l
		]),
		hasRole: d,
		hasAnyRole: f,
		hasPermission: p
	};
}
//#endregion
//#region src/hooks/useHasHydrated.ts
function bn() {
	let [e, t] = f(() => X.persist?.hasHydrated?.() ?? !1);
	return l(() => {
		if (e) return;
		let n = X.persist?.onFinishHydration?.(() => {
			t(!0);
		});
		return X.persist?.hasHydrated?.() && t(!0), () => {
			n?.();
		};
	}, [e]), e;
}
//#endregion
//#region src/hooks/useAuthGuard.ts
function xn(e = {}) {
	let { requiredRoles: t = [], requiredPermissions: n = [], requireAllRoles: r = !1 } = e, i = bn(), a = X((e) => e.user), o = X((e) => e.isAuthenticated), s = X((e) => e.hasRole), c = X((e) => e.hasPermission), l = !i;
	return {
		...u(() => {
			if (!o || !a) return {
				isAllowed: !1,
				isAuthenticated: !1,
				missingRoles: t,
				missingPermissions: n,
				denyReason: "not_authenticated"
			};
			let e = [], i = !0;
			t.length > 0 && (r ? (e = t.filter((e) => !s(e)), i = e.length === 0) : t.some((e) => s(e)) || (e = t, i = !1));
			let l = n.filter((e) => !c(e)), u = l.length === 0;
			return i ? u ? {
				isAllowed: !0,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: [],
				denyReason: "none"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: l,
				denyReason: "missing_permissions"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: e,
				missingPermissions: l,
				denyReason: "missing_roles"
			};
		}, [
			o,
			a,
			t,
			n,
			r,
			s,
			c
		]),
		isLoading: l,
		user: a
	};
}
//#endregion
//#region src/hooks/useTokenRefresh.ts
var Sn = 300 * 1e3, Cn = 3, wn = 1e3, $ = null;
function Tn() {
	return $;
}
function En() {
	$ = null;
}
function Dn(e = {}) {
	let { refreshThreshold: t = Sn, maxRetries: n = Cn, retryBaseDelay: r = wn, onRefreshError: i, onSessionExpired: a } = e, [o, c] = f(!1), [u, p] = f(null), [m, h] = f(0), [g, _] = f(null), v = d(null), y = d(null), b = d(!0), x = X((e) => e.refreshToken), S = X((e) => e.expiresAt), C = X((e) => e.isAuthenticated), w = X((e) => e.updateToken), T = X((e) => e.logout), E = s(() => {
		v.current &&= (clearTimeout(v.current), null);
	}, []), D = s(() => {
		y.current &&= (clearInterval(y.current), null);
	}, []), O = s(async (e = 0) => {
		if ($) return $;
		if (!x) throw new Z("No refresh token available", "NO_REFRESH_TOKEN", 401);
		return $ = (async () => {
			try {
				b.current && (c(!0), h(e));
				let t = await Wt(x);
				b.current && (w(t.accessToken, t.expiresIn, t.refreshToken), p(/* @__PURE__ */ new Date()), h(0));
			} catch (t) {
				let o = t instanceof Z ? t : new Z(t instanceof Error ? t.message : "Unknown error", "REFRESH_ERROR", 0);
				if (o.status === 401 || o.status === 422) throw b.current && (T(), zt()), a?.(), o;
				if (o.code === "NETWORK_ERROR" && e < n) {
					let t = r * 2 ** e;
					return await new Promise((e) => setTimeout(e, t)), $ = null, O(e + 1);
				}
				throw i?.(o), o;
			} finally {
				$ = null, b.current && c(!1);
			}
		})(), $;
	}, [
		x,
		w,
		T,
		n,
		r,
		i,
		a
	]), k = s(() => {
		if (E(), !S || !C) return;
		let e = Date.now(), n = S - t - e;
		n <= 0 ? O().catch(() => {}) : v.current = setTimeout(() => {
			document.visibilityState === "visible" && O().catch(() => {});
		}, n);
	}, [
		S,
		C,
		t,
		E,
		O
	]), A = s(() => {
		document.visibilityState === "visible" ? S && C && (S - Date.now() <= t ? O().catch(() => {}) : k()) : E();
	}, [
		S,
		C,
		t,
		O,
		k,
		E
	]), j = s(async () => O(0), [O]);
	return l(() => {
		if (D(), !S || !C) {
			_(null);
			return;
		}
		let e = () => {
			let e = S - Date.now();
			_(e > 0 ? e : 0);
		};
		return e(), y.current = setInterval(e, 1e3), () => {
			D();
		};
	}, [
		S,
		C,
		D
	]), l(() => {
		k();
	}, [k]), l(() => (document.addEventListener("visibilitychange", A), () => {
		document.removeEventListener("visibilitychange", A);
	}), [A]), l(() => (b.current = !0, () => {
		b.current = !1, E(), D();
	}), [E, D]), {
		isRefreshing: o,
		lastRefresh: u,
		refresh: j,
		timeUntilExpiry: g,
		retryCount: m
	};
}
//#endregion
//#region src/hooks/useFacebookAuth.ts
function On(e) {
	let { appId: t, onSuccess: n, onError: r } = e, i = X((e) => e.login), a = X((e) => e.setLoading), [o, c] = f(!1), [u, p] = f(!1), [m, h] = f(null), g = d(!1);
	l(() => {
		if (window.FB) {
			p(!0);
			return;
		}
		if (g.current) return;
		if (document.getElementById("facebook-jssdk")) {
			g.current = !0;
			return;
		}
		g.current = !0, window.fbAsyncInit = () => {
			window.FB?.init({
				appId: t,
				version: "v18.0",
				cookie: !0,
				xfbml: !1
			}), p(!0);
		};
		let e = document.createElement("script");
		e.id = "facebook-jssdk", e.src = "https://connect.facebook.net/en_US/sdk.js", e.async = !0, e.defer = !0, document.body.appendChild(e);
	}, [t]);
	let _ = s(async (e) => {
		if (e.status !== "connected" || !e.authResponse) {
			let t = /* @__PURE__ */ Error(e.status === "not_authorized" ? "Facebook login not authorized. Please grant permissions." : "Facebook login was cancelled or failed");
			h(t), c(!1), a(!1), r?.(t);
			return;
		}
		try {
			let t = await rn({ accessToken: e.authResponse.accessToken }), r = await Jt(t.accessToken), a = q({
				...r,
				user_guid: r.user_guid || t.user.guid,
				email: r.email || t.user.email || void 0
			});
			i(t.accessToken, t.refreshToken, t.expiresIn, a), n?.(t, a);
		} catch (e) {
			let t = e instanceof Error ? e : /* @__PURE__ */ Error("Facebook authentication failed");
			h(t), a(!1), r?.(t);
		} finally {
			c(!1);
		}
	}, [
		i,
		a,
		n,
		r
	]);
	return {
		login: s(() => {
			if (!u || !window.FB) {
				let e = /* @__PURE__ */ Error("Facebook SDK not ready. Please try again.");
				h(e), r?.(e);
				return;
			}
			c(!0), a(!0), h(null), window.FB.getLoginStatus((e) => {
				e.status === "connected" && e.authResponse ? _(e) : window.FB.login((e) => {
					_(e);
				}, { scope: "email,public_profile" });
			});
		}, [
			u,
			_,
			a,
			r
		]),
		isLoading: o,
		isReady: u,
		error: m
	};
}
//#endregion
//#region ../node_modules/zod/v4/core/core.js
var kn;
function An(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var jn = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
};
(kn = globalThis).__zod_globalConfig ?? (kn.__zod_globalConfig = {});
var Mn = globalThis.__zod_globalConfig;
function Nn(e) {
	return e && Object.assign(Mn, e), Mn;
}
//#endregion
//#region ../node_modules/zod/v4/core/util.js
function Pn(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
var Fn = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
-Number.MAX_VALUE, Number.MAX_VALUE;
function In(e) {
	return typeof e == "string" ? e : e?.message;
}
function Ln(e, t, n) {
	let r = e.message ? e.message : In(e.inst?._zod.def?.error?.(e)) ?? In(t?.error?.(e)) ?? In(n.customError?.(e)) ?? In(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: a, input: o, ...s } = e;
	return s.path ??= [], s.message = r, t?.reportInput && (s.input = o), s;
}
//#endregion
//#region ../node_modules/zod/v4/core/errors.js
var Rn = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, Pn, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, zn = An("$ZodError", Rn), Bn = /* @__PURE__*/ ((e) => (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !1
	} : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new jn();
	if (o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => Ln(e, a, Nn())));
		throw Fn(t, i?.callee), t;
	}
	return o.value;
})(An("$ZodError", Rn, { Parent: Error }));
//#endregion
//#region ../node_modules/mantine-form-zod-resolver/dist/esm/index.mjs
function Vn(e, t) {
	return (n) => {
		try {
			return Bn(e, n), {};
		} catch (e) {
			if (e instanceof zn) {
				let n = {};
				return t?.errorPriority === "first" && e.issues.reverse(), e.issues.forEach((e) => {
					n[e.path.join(".")] = e.message;
				}), n;
			}
			throw e;
		}
	};
}
//#endregion
//#region src/utils/describeOAuthError.ts
function Hn(e, t) {
	if (e instanceof Z) switch (e.status) {
		case 401: return t("oauth.errors.session_expired");
		case 422: return t("oauth.errors.malformed_link");
		case 429: return t("oauth.errors.rate_limited");
		case 503: return t("oauth.errors.service_unavailable");
		case 0: return t("oauth.errors.network");
		default: return e.message || t("oauth.errors.generic");
	}
	return e instanceof Error ? e.message : t("oauth.errors.generic");
}
//#endregion
//#region src/components/GoogleLoginButton/GoogleLoginButton.tsx
function Un(e) {
	if (e) return e.startsWith("/") && !e.startsWith("//") ? e : void 0;
}
function Wn({ returnUrl: e, onError: t, label: n, iconOnly: r = !1, ...i }) {
	let { t: a } = R("auth"), [o, c] = f(!1), [l, u] = f(null), d = s(async () => {
		c(!0), u(null);
		try {
			let { authorizationUrl: t } = await en(Un(e));
			window.location.assign(t);
		} catch (e) {
			c(!1), u(Hn(e, a)), t?.(e instanceof Error ? e : Error(a("oauth.errors.generic")));
		}
	}, [
		e,
		t,
		a
	]), p = n ?? a("oauth.google.button", "Sign in with Google");
	return /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(_, {
		leftSection: r ? void 0 : /* @__PURE__ */ B(ae, { size: 18 }),
		onClick: d,
		loading: o,
		variant: "default",
		...i,
		"aria-label": p,
		"data-testid": "google-login-button",
		children: r ? /* @__PURE__ */ B(ae, { size: 18 }) : p
	}), l && /* @__PURE__ */ B(j, {
		size: "xs",
		c: "red",
		"data-testid": "google-login-error",
		children: l
	})] });
}
//#endregion
//#region src/components/FacebookLoginButton/FacebookLoginButton.tsx
function Gn({ appId: e, onSuccess: t, onError: n, label: r, iconOnly: i = !1, ...a }) {
	let { t: o } = R("auth"), { login: s, isLoading: c, isReady: l } = On({
		appId: e,
		onSuccess: t,
		onError: n
	}), u = r ?? o("oauth.facebook.button", "Sign in with Facebook");
	return i ? /* @__PURE__ */ B(_, {
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: /* @__PURE__ */ B(ie, { size: 18 })
	}) : /* @__PURE__ */ B(_, {
		leftSection: /* @__PURE__ */ B(ie, { size: 18 }),
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: u
	});
}
//#endregion
//#region src/components/TelegramLoginButton/TelegramIcon.tsx
function Kn({ size: e = 18, ...t }) {
	return /* @__PURE__ */ B("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: e,
		height: e,
		viewBox: "84 154 760 760",
		fill: "currentColor",
		"aria-hidden": "true",
		focusable: "false",
		"data-testid": "telegram-icon",
		...t,
		children: /* @__PURE__ */ B("path", { d: "M226.328419,494.722069 C372.088573,431.216685 469.284839,389.350049 517.917216,369.122161 C656.772535,311.36743 685.625481,301.334815 704.431427,301.003532 C708.567621,300.93067 717.815839,301.955743 723.806446,306.816707 C728.864797,310.92121 730.256552,316.46581 730.922551,320.357329 C731.588551,324.248848 732.417879,333.113828 731.758626,340.040666 C724.234007,419.102486 691.675104,610.964674 675.110982,699.515267 C668.10208,736.984342 654.301336,749.547532 640.940618,750.777006 C611.904684,753.448938 589.856115,731.588035 561.733393,713.153237 C517.726886,684.306416 492.866009,666.349181 450.150074,638.200013 C400.78442,605.66878 432.786119,587.789048 460.919462,558.568563 C468.282091,550.921423 596.21508,434.556479 598.691227,424.000355 C599.00091,422.680135 599.288312,417.758981 596.36474,415.160431 C593.441168,412.561881 589.126229,413.450484 586.012448,414.157198 C581.598758,415.158943 511.297793,461.625274 375.109553,553.556189 C355.154858,567.258623 337.080515,573.934908 320.886524,573.585046 C303.033948,573.199351 268.692754,563.490928 243.163606,555.192408 C211.851067,545.013936 186.964484,539.632504 189.131547,522.346309 C190.260287,513.342589 202.659244,504.134509 226.328419,494.722069 Z" })
	});
}
//#endregion
//#region src/components/TelegramLoginButton/TelegramLoginButton.tsx
function qn(e) {
	if (e) return e.startsWith("/") && !e.startsWith("//") ? e : void 0;
}
function Jn({ returnUrl: e, onError: t, label: n, iconOnly: r = !1, ...i }) {
	let { t: a } = R("auth"), [o, c] = f(!1), [l, u] = f(null), d = s(async () => {
		c(!0), u(null);
		try {
			let { authorizationUrl: t } = await an(qn(e));
			window.location.assign(t);
		} catch (e) {
			c(!1), u(Hn(e, a)), t?.(e instanceof Error ? e : Error(a("oauth.errors.generic")));
		}
	}, [
		e,
		t,
		a
	]), p = n ?? a("oauth.telegram.button", "Log in with Telegram");
	return /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(_, {
		leftSection: r ? void 0 : /* @__PURE__ */ B(Kn, { size: 18 }),
		onClick: d,
		loading: o,
		variant: "default",
		...i,
		"aria-label": p,
		"data-testid": "telegram-login-button",
		children: r ? /* @__PURE__ */ B(Kn, { size: 18 }) : p
	}), l && /* @__PURE__ */ B(j, {
		size: "xs",
		c: "red",
		"data-testid": "telegram-login-error",
		children: l
	})] });
}
//#endregion
//#region src/components/SocialLoginButtons/SocialLoginButtons.tsx
function Yn({ google: e = !0, facebook: t = !0, telegram: n = !0, facebookAppId: r, returnUrl: i, onSuccess: a, onError: o, showDivider: s = !0, dividerText: c, layout: l = "vertical", ...u }) {
	let { t: d } = R("auth");
	t && !r && console.warn("SocialLoginButtons: facebookAppId is required when facebook=true");
	let f = (e) => (t, n) => {
		a?.(t, n, e);
	}, p = (e) => (t) => {
		o?.(t, e);
	};
	if ([
		e,
		t && r,
		n
	].filter(Boolean).length === 0) return null;
	let m = /* @__PURE__ */ V(z, { children: [
		e && /* @__PURE__ */ B(Wn, {
			returnUrl: i,
			onError: p("google"),
			fullWidth: l === "vertical"
		}),
		t && r && /* @__PURE__ */ B(Gn, {
			appId: r,
			onSuccess: f("facebook"),
			onError: p("facebook"),
			fullWidth: l === "vertical"
		}),
		n && /* @__PURE__ */ B(Jn, {
			returnUrl: i,
			onError: p("telegram"),
			fullWidth: l === "vertical"
		})
	] });
	return /* @__PURE__ */ V(A, {
		gap: "sm",
		...u,
		"data-testid": "social-login-buttons",
		children: [s && /* @__PURE__ */ B(x, {
			label: /* @__PURE__ */ B(j, {
				size: "sm",
				c: "dimmed",
				children: c || d("oauth.divider", "or")
			}),
			labelPosition: "center"
		}), l === "vertical" ? /* @__PURE__ */ B(A, {
			gap: "xs",
			children: m
		}) : /* @__PURE__ */ B(S, {
			gap: "xs",
			justify: "center",
			children: m
		})]
	});
}
//#endregion
//#region src/components/LoginForm/LoginForm.tsx
var Xn = L.object({
	email: L.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	password: L.string().min(1, "login.errors.password_required")
}), Zn = L.object({
	email: L.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	code: L.string().min(6, "login.errors.code_invalid").max(6, "login.errors.code_invalid")
});
function Qn({ onSuccess: e, onError: t, disabled: n = !1, showSocialLogin: r = !0, facebookAppId: i, returnUrl: a, onSocialSuccess: o, onSocialError: c, showCodeLogin: u = !0, defaultMethod: d = "password" }) {
	let { t: h } = R("auth"), { loginWithCredentials: g, loginByCode: v, isLoading: y } = yn(), [b, S] = f(null), [C, w] = f(d), [T, E] = f(!1), [O, N] = f(!1), P = ne({
		initialValues: {
			email: "",
			password: ""
		},
		validate: Vn(Xn)
	}), F = ne({
		initialValues: {
			email: "",
			code: ""
		},
		validate: Vn(Zn)
	});
	l(() => {
		C === "code" ? F.setFieldValue("email", P.values.email) : P.setFieldValue("email", F.values.email), S(null);
	}, [C]);
	let ee = s(async (n) => {
		S(null);
		try {
			let t = await g({
				email: n.email,
				password: n.password
			});
			e?.(t);
		} catch (e) {
			let n = $n(e, h);
			S(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		g,
		e,
		t,
		h
	]), te = s(async () => {
		if (!F.validateField("email").hasError) {
			S(null), N(!0);
			try {
				await Kt(F.values.email), E(!0);
			} catch (e) {
				S(er(e, h));
			} finally {
				N(!1);
			}
		}
	}, [F, h]), re = s(async (n) => {
		S(null);
		try {
			let t = await v(n.email, n.code);
			e?.(t);
		} catch (e) {
			let n = er(e, h);
			S(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		v,
		e,
		t,
		h
	]), ie = s(() => {
		E(!1), F.setFieldValue("code", ""), S(null);
	}, [F]), ae = s((t, n, r) => {
		e?.(n), o?.(t, r);
	}, [e, o]), oe = y || n;
	return /* @__PURE__ */ V(A, {
		gap: "md",
		children: [
			r && /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(Yn, {
				facebookAppId: i,
				returnUrl: a,
				onSuccess: ae,
				onError: c,
				showDivider: !1
			}), /* @__PURE__ */ B(x, {
				label: /* @__PURE__ */ B(j, {
					size: "sm",
					c: "dimmed",
					children: h("login.or_with_email")
				}),
				labelPosition: "center"
			})] }),
			b && /* @__PURE__ */ B(p, {
				icon: /* @__PURE__ */ B(I, { size: 16 }),
				color: "red",
				variant: "light",
				title: h("login.error_title"),
				"aria-live": "polite",
				"data-testid": "login-error",
				children: b
			}),
			u && /* @__PURE__ */ B(k, {
				value: C,
				onChange: (e) => w(e),
				data: [{
					label: h("login.method_password"),
					value: "password"
				}, {
					label: h("login.method_code"),
					value: "code"
				}],
				fullWidth: !0,
				"data-testid": "login-method-toggle"
			}),
			C === "password" && /* @__PURE__ */ B("form", {
				onSubmit: P.onSubmit(ee),
				noValidate: !0,
				children: /* @__PURE__ */ V(A, {
					gap: "md",
					children: [
						/* @__PURE__ */ B(M, {
							label: h("login.email_label"),
							placeholder: h("login.email_placeholder"),
							leftSection: /* @__PURE__ */ B(pe, { size: 16 }),
							autoComplete: "email",
							type: "email",
							inputMode: "email",
							"data-autofocus": !0,
							"data-testid": "login-email",
							"aria-label": h("login.email_label"),
							"aria-required": "true",
							"aria-invalid": !!P.errors.email,
							disabled: oe,
							...P.getInputProps("email"),
							error: P.errors.email ? h(P.errors.email) : void 0
						}),
						/* @__PURE__ */ B(D, {
							label: h("login.password_label"),
							placeholder: h("login.password_placeholder"),
							leftSection: /* @__PURE__ */ B(de, { size: 16 }),
							autoComplete: "current-password",
							"data-testid": "login-password",
							"aria-label": h("login.password_label"),
							"aria-required": "true",
							"aria-invalid": !!P.errors.password,
							disabled: oe,
							...P.getInputProps("password"),
							error: P.errors.password ? h(P.errors.password) : void 0
						}),
						/* @__PURE__ */ B(_, {
							type: "submit",
							fullWidth: !0,
							loading: y,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: h("login.submit")
						})
					]
				})
			}),
			C === "code" && /* @__PURE__ */ B("form", {
				onSubmit: F.onSubmit(re),
				noValidate: !0,
				children: /* @__PURE__ */ V(A, {
					gap: "md",
					children: [/* @__PURE__ */ B(M, {
						label: h("login.email_label"),
						placeholder: h("login.email_placeholder"),
						leftSection: /* @__PURE__ */ B(pe, { size: 16 }),
						autoComplete: "email",
						type: "email",
						inputMode: "email",
						"data-autofocus": !0,
						"data-testid": "login-email",
						"aria-label": h("login.email_label"),
						"aria-required": "true",
						"aria-invalid": !!F.errors.email,
						disabled: oe || T,
						...F.getInputProps("email"),
						error: F.errors.email ? h(F.errors.email) : void 0
					}), T ? /* @__PURE__ */ V(z, { children: [
						/* @__PURE__ */ B(j, {
							size: "sm",
							c: "teal",
							"data-testid": "login-code-sent-msg",
							children: h("login.code_sent")
						}),
						/* @__PURE__ */ B(M, {
							label: h("login.code"),
							placeholder: "000000",
							leftSection: /* @__PURE__ */ B(me, { size: 16 }),
							autoComplete: "one-time-code",
							inputMode: "numeric",
							maxLength: 6,
							"data-testid": "login-code",
							"aria-label": h("login.code"),
							"aria-required": "true",
							"aria-invalid": !!F.errors.code,
							disabled: oe,
							...F.getInputProps("code"),
							error: F.errors.code ? h(F.errors.code) : void 0
						}),
						/* @__PURE__ */ B(_, {
							type: "submit",
							fullWidth: !0,
							loading: y,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: h("login.verify_and_sign_in")
						}),
						/* @__PURE__ */ B(m, {
							component: "button",
							type: "button",
							size: "sm",
							ta: "center",
							onClick: ie,
							"data-testid": "login-resend-code",
							children: h("login.resend_code")
						})
					] }) : /* @__PURE__ */ B(_, {
						fullWidth: !0,
						variant: "light",
						loading: O,
						disabled: n,
						onClick: te,
						"data-testid": "login-send-code",
						mt: "xs",
						children: h("login.send_code")
					})]
				})
			})
		]
	});
}
function $n(e, t) {
	if (e instanceof Z) switch (e.code) {
		case "INVALID_CREDENTIALS": return t("login.errors.invalid_credentials");
		case "ACCOUNT_LOCKED": return t("login.errors.account_locked");
		case "ACCOUNT_DISABLED": return t("login.errors.account_disabled");
		case "EMAIL_NOT_VERIFIED": return t("login.errors.email_not_verified");
		default: return e.message || t("login.errors.generic");
	}
	return e instanceof Error && e.message || t("login.errors.generic");
}
function er(e, t) {
	if (e instanceof Z) switch (e.code) {
		case "CODE_EXPIRED": return t("login.errors.code_expired");
		case "RATE_LIMITED": return t("login.errors.code_rate_limited");
		case "INVALID_CODE": {
			let n = e.details?.remaining;
			return n === void 0 ? t("login.errors.code_invalid_value", { remaining: "?" }) : t("login.errors.code_invalid_value", { remaining: n });
		}
		default: return e.message || t("login.errors.code_send_failed");
	}
	return e instanceof Error && e.message || t("login.errors.code_send_failed");
}
//#endregion
//#region src/components/LoginModal/LoginModal.tsx
function tr({ opened: e, onClose: t, onSuccess: n, onError: r, title: i, subtitle: a, closeOnSuccess: o = !0, size: c = "sm", centered: l = !0, showSocialLogin: u = !1, showCodeLogin: d, defaultMethod: f, facebookAppId: p, returnUrl: m }) {
	let { t: h } = R("auth"), g = s((e) => {
		n?.(e), o && t();
	}, [
		n,
		t,
		o
	]);
	return /* @__PURE__ */ B(T, {
		opened: e,
		onClose: t,
		title: i || h("login.modal_title"),
		size: c,
		centered: l,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !0,
		"aria-labelledby": "login-modal-title",
		"data-testid": "login-modal",
		children: /* @__PURE__ */ V(A, {
			gap: "md",
			children: [a && /* @__PURE__ */ B(j, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: a
			}), /* @__PURE__ */ B(Qn, {
				onSuccess: g,
				onError: r,
				showSocialLogin: u,
				showCodeLogin: d,
				defaultMethod: f,
				facebookAppId: p,
				returnUrl: m
			})]
		})
	});
}
//#endregion
//#region src/components/LoginPage/LoginPage.tsx
function nr({ onSuccess: e, onError: t, redirectOnSuccess: n, logo: r, backgroundImage: i, title: a, subtitle: o, maxWidth: c = 420, showSocialLogin: l = !1, showCodeLogin: u, defaultMethod: d, facebookAppId: f, returnUrl: p }) {
	let { t: m } = R("auth"), h = te(), _ = ee("light") === "dark", y = s((t) => {
		e?.(t), n && typeof window < "u" && (window.location.href = n);
	}, [e, n]);
	return /* @__PURE__ */ B(v, {
		mih: "100vh",
		style: {
			...i ? {
				backgroundImage: `url(${i})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat"
			} : {},
			backgroundColor: i ? void 0 : _ ? h.colors.dark[8] : h.colors.gray[0]
		},
		"data-testid": "login-page",
		children: /* @__PURE__ */ B(g, {
			w: {
				base: "100%",
				sm: c
			},
			px: "md",
			py: "xl",
			children: /* @__PURE__ */ V(A, {
				gap: "lg",
				align: "center",
				children: [
					r && /* @__PURE__ */ B(g, {
						mb: "md",
						"data-testid": "login-page-logo",
						children: r
					}),
					/* @__PURE__ */ B(E, {
						p: "xl",
						shadow: "md",
						radius: "md",
						withBorder: !0,
						w: "100%",
						style: i ? {
							backgroundColor: "rgba(255, 255, 255, 0.95)",
							backdropFilter: "blur(10px)"
						} : void 0,
						children: /* @__PURE__ */ V(A, {
							gap: "md",
							children: [
								/* @__PURE__ */ B(P, {
									order: 2,
									ta: "center",
									"data-testid": "login-page-title",
									children: a || m("login.page_title")
								}),
								(o || !a) && /* @__PURE__ */ B(j, {
									size: "sm",
									c: "dimmed",
									ta: "center",
									children: o || m("login.page_subtitle")
								}),
								/* @__PURE__ */ B(Qn, {
									onSuccess: y,
									onError: t,
									showSocialLogin: l,
									showCodeLogin: u,
									defaultMethod: d,
									facebookAppId: f,
									returnUrl: p
								})
							]
						})
					}),
					/* @__PURE__ */ B(j, {
						size: "xs",
						c: "dimmed",
						ta: "center",
						children: m("login.help_text")
					})
				]
			})
		})
	});
}
//#endregion
//#region src/components/RegisterForm/PasswordStrengthIndicator.tsx
function rr(e) {
	return [
		{
			key: "length",
			label: "password.requirements.length",
			met: e.length >= 8
		},
		{
			key: "uppercase",
			label: "password.requirements.uppercase",
			met: /[A-Z]/.test(e)
		},
		{
			key: "lowercase",
			label: "password.requirements.lowercase",
			met: /[a-z]/.test(e)
		},
		{
			key: "number",
			label: "password.requirements.number",
			met: /[0-9]/.test(e)
		}
	];
}
function ir(e) {
	if (!e) return 0;
	let t = rr(e), n = t.filter((e) => e.met).length / t.length * 80, r = /[!@#$%^&*(),.?":{}|<>]/.test(e) ? 10 : 0, i = Math.min(10, Math.max(0, e.length - 8));
	return Math.min(100, n + r + i);
}
function ar(e) {
	return e < 30 ? "red" : e < 60 ? "yellow" : e < 80 ? "lime" : "green";
}
function or(e) {
	return e < 30 ? "password.strength.weak" : e < 60 ? "password.strength.fair" : e < 80 ? "password.strength.good" : "password.strength.strong";
}
function sr({ met: e, label: t }) {
	let { t: n } = R("auth");
	return /* @__PURE__ */ V(S, {
		gap: "xs",
		wrap: "nowrap",
		children: [/* @__PURE__ */ B(N, {
			size: "xs",
			radius: "xl",
			color: e ? "green" : "red",
			variant: "light",
			children: B(e ? se : ve, { size: 10 })
		}), /* @__PURE__ */ B(j, {
			size: "xs",
			c: e ? "dimmed" : void 0,
			style: { textDecoration: e ? "line-through" : void 0 },
			children: n(t)
		})]
	});
}
function cr({ password: e, showRequirements: t = !0, compact: n = !1 }) {
	let { t: r } = R("auth"), i = u(() => ir(e), [e]), a = u(() => rr(e), [e]), o = ar(i), s = or(i);
	return e ? n ? /* @__PURE__ */ B(O, {
		value: i,
		color: o,
		size: "xs",
		"aria-label": r("password.strength.label"),
		"aria-valuenow": i,
		"aria-valuemin": 0,
		"aria-valuemax": 100
	}) : /* @__PURE__ */ V(A, {
		gap: "xs",
		"data-testid": "password-strength-indicator",
		children: [
			/* @__PURE__ */ V(S, {
				justify: "space-between",
				gap: "xs",
				children: [/* @__PURE__ */ B(j, {
					size: "xs",
					c: "dimmed",
					children: r("password.strength.label")
				}), /* @__PURE__ */ B(j, {
					size: "xs",
					c: o,
					fw: 500,
					children: r(s)
				})]
			}),
			/* @__PURE__ */ B(O, {
				value: i,
				color: o,
				size: "sm",
				"aria-label": r("password.strength.label"),
				"aria-valuenow": i,
				"aria-valuemin": 0,
				"aria-valuemax": 100,
				"data-testid": "password-strength-progress"
			}),
			t && /* @__PURE__ */ B(g, {
				mt: "xs",
				children: /* @__PURE__ */ B(A, {
					gap: 4,
					children: a.map((e) => /* @__PURE__ */ B(sr, {
						met: e.met,
						label: e.label
					}, e.key))
				})
			})
		]
	}) : null;
}
//#endregion
//#region src/components/RegisterForm/RegisterForm.tsx
var lr = L.object({
	name: L.string().min(1, "register.errors.name_required").max(100, "register.errors.name_too_long"),
	email: L.string().min(1, "register.errors.email_required").email("register.errors.email_invalid"),
	password: L.string().min(8, "register.errors.password_min_length").refine((e) => /[A-Z]/.test(e), "register.errors.password_uppercase").refine((e) => /[a-z]/.test(e), "register.errors.password_lowercase").refine((e) => /[0-9]/.test(e), "register.errors.password_number"),
	confirmPassword: L.string().min(1, "register.errors.confirm_password_required"),
	acceptTerms: L.boolean().refine((e) => e === !0, "register.errors.terms_required")
}).refine((e) => e.password === e.confirmPassword, {
	message: "register.errors.passwords_mismatch",
	path: ["confirmPassword"]
});
function ur({ onSuccess: e, onError: t, showLogin: n = !1, onLoginClick: r, termsUrl: i = "/terms", privacyUrl: a = "/privacy", submitLabel: o, disabled: c = !1, showPasswordStrength: l = !0, showSocialLogin: u = !1, facebookAppId: d, returnUrl: h, onSocialSuccess: g, onSocialError: v }) {
	let { t: b } = R("auth"), [C, w] = f(!1), [T, E] = f(null), O = ne({
		initialValues: {
			name: "",
			email: "",
			password: "",
			confirmPassword: "",
			acceptTerms: !1
		},
		validate: Vn(lr)
	}), k = s((e) => rr(e).every((e) => e.met), []), N = s(async (n) => {
		E(null), w(!0);
		try {
			await Ut({
				email: n.email,
				password: n.password,
				firstName: n.name.split(" ")[0],
				lastName: n.name.split(" ").slice(1).join(" ") || void 0
			}), e?.();
		} catch (e) {
			let n;
			if (e instanceof Z) switch (e.code) {
				case "EMAIL_EXISTS":
				case "USER_EXISTS":
					n = b("register.errors.email_exists");
					break;
				case "VALIDATION_ERROR":
					n = b("register.errors.validation_error");
					break;
				case "RATE_LIMITED":
					n = b("register.errors.rate_limited");
					break;
				default: n = e.message || b("register.errors.generic");
			}
			else n = e instanceof Error && e.message || b("register.errors.generic");
			E(n), t?.(e instanceof Error ? e : Error(n));
		} finally {
			w(!1);
		}
	}, [
		e,
		t,
		b
	]), P = C || c, F = O.values.password && !k(O.values.password), ee = s((t, n, r) => {
		e?.(n), g?.(t, r);
	}, [e, g]);
	return /* @__PURE__ */ B("form", {
		onSubmit: O.onSubmit(N),
		noValidate: !0,
		children: /* @__PURE__ */ V(A, {
			gap: "md",
			children: [
				u && /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(Yn, {
					facebookAppId: d,
					returnUrl: h,
					onSuccess: ee,
					onError: v,
					showDivider: !1
				}), /* @__PURE__ */ B(x, {
					label: /* @__PURE__ */ B(j, {
						size: "sm",
						c: "dimmed",
						children: b("register.or_email", "or with email")
					}),
					labelPosition: "center"
				})] }),
				T && /* @__PURE__ */ B(p, {
					icon: /* @__PURE__ */ B(I, { size: 16 }),
					color: "red",
					variant: "light",
					title: b("register.error_title"),
					"aria-live": "polite",
					"data-testid": "register-error",
					children: T
				}),
				/* @__PURE__ */ B(M, {
					label: b("register.name_label"),
					placeholder: b("register.name_placeholder"),
					leftSection: /* @__PURE__ */ B(ge, { size: 16 }),
					autoComplete: "name",
					"data-autofocus": !0,
					"data-testid": "register-name",
					"aria-label": b("register.name_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.name,
					disabled: P,
					...O.getInputProps("name"),
					error: O.errors.name ? b(O.errors.name) : void 0
				}),
				/* @__PURE__ */ B(M, {
					label: b("register.email_label"),
					placeholder: b("register.email_placeholder"),
					leftSection: /* @__PURE__ */ B(pe, { size: 16 }),
					autoComplete: "email",
					type: "email",
					inputMode: "email",
					"data-testid": "register-email",
					"aria-label": b("register.email_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.email,
					disabled: P,
					...O.getInputProps("email"),
					error: O.errors.email ? b(O.errors.email) : void 0
				}),
				/* @__PURE__ */ V(A, {
					gap: "xs",
					children: [/* @__PURE__ */ B(D, {
						label: b("register.password_label"),
						placeholder: b("register.password_placeholder"),
						leftSection: /* @__PURE__ */ B(de, { size: 16 }),
						autoComplete: "new-password",
						"data-testid": "register-password",
						"aria-label": b("register.password_label"),
						"aria-required": "true",
						"aria-invalid": !!O.errors.password,
						"aria-describedby": "password-requirements",
						disabled: P,
						...O.getInputProps("password"),
						error: O.errors.password ? b(O.errors.password) : void 0
					}), l && /* @__PURE__ */ B("div", {
						id: "password-requirements",
						children: /* @__PURE__ */ B(cr, {
							password: O.values.password,
							showRequirements: !0
						})
					})]
				}),
				/* @__PURE__ */ B(D, {
					label: b("register.confirm_password_label"),
					placeholder: b("register.confirm_password_placeholder"),
					leftSection: /* @__PURE__ */ B(de, { size: 16 }),
					autoComplete: "new-password",
					"data-testid": "register-confirm-password",
					"aria-label": b("register.confirm_password_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.confirmPassword,
					disabled: P,
					...O.getInputProps("confirmPassword"),
					error: O.errors.confirmPassword ? b(O.errors.confirmPassword) : void 0
				}),
				/* @__PURE__ */ B(y, {
					label: /* @__PURE__ */ V(z, { children: [
						b("register.terms_prefix"),
						" ",
						/* @__PURE__ */ B(m, {
							href: i,
							target: "_blank",
							size: "sm",
							children: b("register.terms_link")
						}),
						" ",
						b("register.terms_and"),
						" ",
						/* @__PURE__ */ B(m, {
							href: a,
							target: "_blank",
							size: "sm",
							children: b("register.privacy_link")
						})
					] }),
					"data-testid": "register-terms",
					"aria-required": "true",
					"aria-invalid": !!O.errors.acceptTerms,
					disabled: P,
					...O.getInputProps("acceptTerms", { type: "checkbox" }),
					error: O.errors.acceptTerms ? b(O.errors.acceptTerms) : void 0
				}),
				/* @__PURE__ */ B(_, {
					type: "submit",
					fullWidth: !0,
					loading: C,
					disabled: c || !!F,
					"data-testid": "register-submit",
					mt: "xs",
					children: o || b("register.submit")
				}),
				n && /* @__PURE__ */ B(S, {
					justify: "center",
					mt: "xs",
					children: /* @__PURE__ */ B(m, {
						component: "button",
						type: "button",
						size: "sm",
						onClick: r,
						"data-testid": "register-login-link",
						children: b("register.have_account")
					})
				})
			]
		})
	});
}
//#endregion
//#region src/components/RegisterModal/VerificationSuccess.tsx
function dr({ email: e, onResendClick: t, onLoginClick: n, title: r, message: i }) {
	let { t: a } = R("auth"), [o, c] = f(!1), [l, u] = f(!1), [d, h] = f(null), g = s(async () => {
		if (t) {
			c(!0), u(!1), h(null);
			try {
				await t(), u(!0);
			} catch (e) {
				h(e instanceof Error ? e.message : a("register.verification.resend_error"));
			} finally {
				c(!1);
			}
		}
	}, [t, a]);
	return /* @__PURE__ */ V(A, {
		gap: "lg",
		align: "center",
		"data-testid": "verification-success",
		children: [
			/* @__PURE__ */ B(v, { children: /* @__PURE__ */ B(N, {
				size: 80,
				radius: 80,
				variant: "light",
				color: "green",
				"aria-hidden": "true",
				children: /* @__PURE__ */ B(pe, { size: 40 })
			}) }),
			/* @__PURE__ */ V(A, {
				gap: "xs",
				align: "center",
				children: [/* @__PURE__ */ B(j, {
					size: "xl",
					fw: 600,
					ta: "center",
					children: r || a("register.verification.title")
				}), /* @__PURE__ */ B(j, {
					size: "sm",
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: i || a("register.verification.message", { email: e })
				})]
			}),
			l && /* @__PURE__ */ B(p, {
				icon: /* @__PURE__ */ B(se, { size: 16 }),
				color: "green",
				variant: "light",
				w: "100%",
				"data-testid": "resend-success",
				children: a("register.verification.resend_success")
			}),
			d && /* @__PURE__ */ B(p, {
				icon: /* @__PURE__ */ B(I, { size: 16 }),
				color: "red",
				variant: "light",
				w: "100%",
				"data-testid": "resend-error",
				children: d
			}),
			/* @__PURE__ */ V(A, {
				gap: "md",
				w: "100%",
				children: [t && /* @__PURE__ */ B(_, {
					variant: "light",
					fullWidth: !0,
					loading: o,
					disabled: l,
					onClick: g,
					"data-testid": "resend-verification",
					children: a(l ? "register.verification.resend_sent" : "register.verification.resend_button")
				}), n && /* @__PURE__ */ B(v, { children: /* @__PURE__ */ B(m, {
					component: "button",
					type: "button",
					size: "sm",
					onClick: n,
					"data-testid": "back-to-login",
					children: a("register.verification.back_to_login")
				}) })]
			})
		]
	});
}
//#endregion
//#region src/components/RegisterModal/RegisterModal.tsx
function fr({ opened: e, onClose: t, onSuccess: n, onError: r, showLogin: i = !1, onLoginClick: a, termsUrl: o, privacyUrl: c, onResendVerification: l, title: u, subtitle: d, size: p = "sm", centered: m = !0, showSocialLogin: h = !1, facebookAppId: g, returnUrl: _ }) {
	let { t: v } = R("auth"), [y, b] = f(!1), [x, S] = f(""), C = s(() => {
		n?.(), b(!0);
	}, [n]), w = s(() => {
		a && a(), t();
	}, [a, t]), E = s(async () => {
		l && x && await l(x);
	}, [l, x]), D = s(() => {
		b(!1), S(""), t();
	}, [t]), O = s(() => {
		C();
	}, [C]);
	return /* @__PURE__ */ B(T, {
		opened: e,
		onClose: D,
		title: y ? v("register.verification.title") : u || v("register.modal_title"),
		size: p,
		centered: m,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !y,
		"aria-labelledby": "register-modal-title",
		"data-testid": "register-modal",
		children: /* @__PURE__ */ V(A, {
			gap: "md",
			children: [!y && d && /* @__PURE__ */ B(j, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: d
			}), y ? /* @__PURE__ */ B(dr, {
				email: x,
				onResendClick: l ? E : void 0,
				onLoginClick: w
			}) : /* @__PURE__ */ B(pr, {
				onSuccess: O,
				onError: r,
				onEmailCapture: S,
				showLogin: i,
				onLoginClick: w,
				termsUrl: o,
				privacyUrl: c,
				showSocialLogin: h,
				facebookAppId: g,
				returnUrl: _
			})]
		})
	});
}
function pr({ onSuccess: e, onError: t, onEmailCapture: n, ...r }) {
	return /* @__PURE__ */ B("div", {
		onSubmitCapture: s((e) => {
			let t = e.currentTarget.querySelector("form");
			if (t) {
				let e = t.querySelector("[data-testid=\"register-email\"]");
				e && n(e.value);
			}
		}, [n]),
		children: /* @__PURE__ */ B(ur, {
			onSuccess: e,
			onError: t,
			...r
		})
	});
}
//#endregion
//#region src/components/AuthGuard/UnauthorizedFallback.tsx
function mr({ title: e, message: t, showBackButton: n = !0, showHomeButton: r = !0, homeUrl: i = "/", onBack: a, onHome: o }) {
	let { t: s } = R("auth");
	return /* @__PURE__ */ V(A, {
		align: "center",
		justify: "center",
		gap: "xl",
		mih: 400,
		p: "xl",
		children: [
			/* @__PURE__ */ B(N, {
				size: 80,
				radius: "xl",
				variant: "light",
				color: "red",
				children: /* @__PURE__ */ B(de, { size: 40 })
			}),
			/* @__PURE__ */ V(A, {
				align: "center",
				gap: "xs",
				children: [/* @__PURE__ */ B(P, {
					order: 2,
					ta: "center",
					children: e || s("guard.unauthorized_title", "Access Denied")
				}), /* @__PURE__ */ B(j, {
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: t || s("guard.unauthorized_message", "You don't have permission to access this page.")
				})]
			}),
			/* @__PURE__ */ V(S, {
				gap: "md",
				children: [n && /* @__PURE__ */ B(_, {
					variant: "default",
					leftSection: /* @__PURE__ */ B(re, { size: 16 }),
					onClick: () => {
						a ? a() : window.history.back();
					},
					children: s("guard.go_back", "Go Back")
				}), r && /* @__PURE__ */ B(_, {
					variant: "filled",
					leftSection: /* @__PURE__ */ B(le, { size: 16 }),
					onClick: () => {
						o ? o() : window.location.href = i;
					},
					children: s("guard.go_home", "Go Home")
				})]
			})
		]
	});
}
//#endregion
//#region src/components/AuthGuard/LoadingFallback.tsx
function hr({ message: e, minHeight: t = "100vh", size: n = "lg" }) {
	let { t: r } = R("auth");
	return /* @__PURE__ */ B(v, {
		mih: t,
		children: /* @__PURE__ */ V(A, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ B(C, { size: n }), /* @__PURE__ */ B(j, {
				c: "dimmed",
				size: "sm",
				children: e || r("guard.loading", "Checking authentication...")
			})]
		})
	});
}
//#endregion
//#region src/components/AuthGuard/redirectUtils.ts
var gr = "returnTo", _r = 2e3;
function vr(e) {
	if (!e || typeof e != "string" || e.length > _r) return !1;
	try {
		if (e.startsWith("/")) return !e.startsWith("//");
		let t = new URL(e, window.location.origin), n = new URL(window.location.origin);
		if (t.origin !== n.origin) {
			let e = t.hostname;
			if (![".teletienda.ar", ".teletienda.local"].some((t) => e.endsWith(t) || e === t.slice(1))) return !1;
		}
		return !0;
	} catch {
		return !1;
	}
}
function yr(e, t) {
	if (!t || !vr(t)) return e;
	try {
		let n = new URL(e, window.location.origin);
		return n.searchParams.set(gr, t), n.origin === window.location.origin ? n.pathname + n.search : n.toString();
	} catch {
		return e;
	}
}
function br() {
	try {
		let e = new URLSearchParams(window.location.search).get(gr);
		return e && vr(e) ? e : null;
	} catch {
		return null;
	}
}
function xr() {
	return window.location.pathname + window.location.search;
}
function Sr(e) {
	let t = vr(e) ? e : "/";
	window.location.href = t;
}
function Cr(e) {
	try {
		let t = new URL(e, window.location.origin), n = window.location;
		return t.pathname === n.pathname && t.search === n.search;
	} catch {
		return !1;
	}
}
//#endregion
//#region src/components/AuthGuard/AuthGuard.tsx
function wr({ children: e, redirectTo: t, preserveReturnUrl: n = !0, fallback: r, loadingComponent: i, onDenied: a, navigate: o, requiredRoles: s, requiredPermissions: c, requireAllRoles: u }) {
	let { isAllowed: f, isLoading: p, isAuthenticated: m, denyReason: h, missingRoles: g, missingPermissions: _ } = xn({
		requiredRoles: s,
		requiredPermissions: c,
		requireAllRoles: u
	}), v = d(!1);
	return l(() => {
		if (!p) {
			if (f) {
				v.current = !1;
				return;
			}
			if (h !== "none" && a && a(h), h === "not_authenticated" && t) {
				if (v.current) return;
				let e = yr(t, n ? xr() : void 0);
				if (Cr(e)) {
					console.warn("[AuthGuard] Redirect loop detected, skipping redirect");
					return;
				}
				v.current = !0, o ? o(e, { replace: !0 }) : Sr(e);
			}
		}
	}, [
		p,
		f,
		m,
		h,
		t,
		n,
		a,
		o
	]), p ? i || /* @__PURE__ */ B(hr, {}) : f ? /* @__PURE__ */ B(z, { children: e }) : m && h !== "not_authenticated" ? r || /* @__PURE__ */ B(mr, {
		missingRoles: g,
		missingPermissions: _
	}) : t ? i || /* @__PURE__ */ B(hr, {}) : r || /* @__PURE__ */ B(mr, {});
}
//#endregion
//#region src/components/AuthGuard/ProtectedRoute.tsx
function Tr({ children: e, element: t, ...n }) {
	let r = t || e;
	return /* @__PURE__ */ B(wr, {
		...n,
		children: r
	});
}
//#endregion
//#region src/components/UserMenu/UserAvatar.tsx
function Er({ src: e, name: t, size: n = "md", radius: r = "xl", className: i }) {
	return /* @__PURE__ */ B(h, {
		src: e,
		name: t,
		alt: t,
		size: n,
		radius: r,
		color: "initials",
		className: i
	});
}
var Dr = {
	userButton: "_userButton_1mcpb_5",
	userName: "_userName_1mcpb_28",
	chevron: "_chevron_1mcpb_32"
};
//#endregion
//#region src/components/UserMenu/UserMenu.tsx
function Or({ showProfile: e = !0, showOrders: t = !1, showFinances: n = !1, profileHref: r = "/profile", ordersHref: i = "/orders", financesHref: a = "/finances", additionalItems: o = [], onLogout: c, confirmLogout: l = !1, logoutRedirect: u, avatarSrc: d, hideUserName: p = !1, children: m }) {
	let { t: h } = R("auth"), { user: g, logout: v, isLoading: y } = yn(), [b, x] = f(!1), [C, { open: E, close: D }] = ye(!1), [O, k] = f(!1), M = be("(max-width: 768px)"), N = p || M, P = s(() => {
		l ? E() : ee();
	}, [l, E]), ee = s(async () => {
		k(!0);
		try {
			let e = u || "/";
			window.location.href = e, await v(), xe.show({
				title: h("userMenu.logout_success_title"),
				message: h("userMenu.logout_success_message"),
				color: "blue",
				autoClose: 3e3
			}), c?.();
		} finally {
			k(!1), D();
		}
	}, [
		v,
		c,
		u,
		D,
		h
	]), te = s(() => {
		ee();
	}, [ee]);
	if (!g) return null;
	let ne = g.name || "", I = [];
	e && I.push({
		label: h("userMenu.profile"),
		icon: ge,
		href: r
	}), t && I.push({
		label: h("userMenu.orders"),
		icon: he,
		href: i
	}), n && I.push({
		label: h("userMenu.finances"),
		icon: _e,
		href: a
	});
	let re = [...I, ...o], ie = (e, t) => {
		let n = [];
		e.dividerBefore && n.push(/* @__PURE__ */ B(w.Divider, {}, `divider-before-${t}`));
		let r = e.icon, i = /* @__PURE__ */ B(w.Item, {
			leftSection: r ? /* @__PURE__ */ B(r, {
				size: 16,
				stroke: 1.5
			}) : void 0,
			onClick: e.onClick,
			component: e.href ? "a" : void 0,
			href: e.href,
			children: e.label
		}, `item-${t}`);
		return n.push(i), e.dividerAfter && n.push(/* @__PURE__ */ B(w.Divider, {}, `divider-after-${t}`)), n;
	};
	return /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ V(w, {
		width: 220,
		position: "bottom-end",
		transitionProps: { transition: "pop-top-right" },
		opened: b,
		onChange: x,
		withinPortal: !0,
		children: [/* @__PURE__ */ B(w.Target, { children: /* @__PURE__ */ B(F, {
			className: Dr.userButton,
			"data-opened": b || void 0,
			"aria-label": h("userMenu.menuLabel"),
			children: /* @__PURE__ */ V(S, {
				gap: "xs",
				wrap: "nowrap",
				children: [/* @__PURE__ */ B(Er, {
					src: d,
					name: ne,
					size: "sm"
				}), !N && /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(j, {
					size: "sm",
					fw: 500,
					className: Dr.userName,
					lineClamp: 1,
					children: ne
				}), /* @__PURE__ */ B(ce, {
					size: 14,
					stroke: 1.5,
					className: Dr.chevron,
					"data-opened": b || void 0
				})] })]
			})
		}) }), /* @__PURE__ */ V(w.Dropdown, { children: [
			re.map((e, t) => ie(e, t)),
			re.length > 0 && /* @__PURE__ */ B(w.Divider, {}),
			/* @__PURE__ */ B(w.Item, {
				color: "red",
				leftSection: /* @__PURE__ */ B(fe, {
					size: 16,
					stroke: 1.5
				}),
				onClick: P,
				disabled: y || O,
				children: h("userMenu.logout")
			}),
			m
		] })]
	}), /* @__PURE__ */ B(T, {
		opened: C,
		onClose: D,
		title: h("userMenu.logoutConfirmTitle"),
		centered: !0,
		size: "sm",
		children: /* @__PURE__ */ V(A, {
			gap: "md",
			children: [/* @__PURE__ */ B(j, {
				size: "sm",
				children: h("userMenu.logoutConfirmMessage")
			}), /* @__PURE__ */ V(S, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ B(_, {
					variant: "default",
					onClick: D,
					disabled: O,
					children: h("userMenu.cancel")
				}), /* @__PURE__ */ B(_, {
					color: "red",
					onClick: te,
					loading: O,
					children: h("userMenu.logout")
				})]
			})]
		})
	})] });
}
//#endregion
//#region src/components/AuthProvider/AuthProvider.tsx
var kr = o(null);
function Ar() {
	let e = c(kr);
	if (!e) throw Error("useAuthContext must be used within AuthProvider");
	return e;
}
function jr({ children: e, apiBaseUrl: t, apiTimeout: n = 3e4, enableCrossTabSync: r = !0, refreshThreshold: i, maxRetries: a, retryBaseDelay: o, onRefreshError: s, onSessionExpired: c }) {
	let d = Dn({
		refreshThreshold: i,
		maxRetries: a,
		retryBaseDelay: o,
		onRefreshError: s,
		onSessionExpired: c
	});
	u(() => {
		ft({
			baseUrl: t,
			timeout: n,
			getToken: () => X.getState().token
		}), mt(() => X.getState().token);
	}, [t, n]), l(() => {
		let e;
		return r && (e = It()), () => {
			e?.();
		};
	}, [r]);
	let f = {
		...d,
		isInitialized: !0
	};
	return /* @__PURE__ */ B(kr.Provider, {
		value: f,
		children: e
	});
}
//#endregion
//#region src/utils/portalOAuthContext.ts
var Mr = "teletienda.oauth.portal", Nr = 600 * 1e3;
function Pr(e) {
	let t = {
		...e,
		savedAt: Date.now()
	};
	try {
		sessionStorage.setItem(Mr, JSON.stringify(t));
	} catch {}
}
function Fr() {
	try {
		sessionStorage.removeItem(Mr);
	} catch {}
}
function Ir() {
	try {
		let e = sessionStorage.getItem(Mr);
		if (sessionStorage.removeItem(Mr), !e) return null;
		let t = JSON.parse(e);
		return typeof t?.domain != "string" || typeof t?.returnUrl != "string" || typeof t.savedAt != "number" || Date.now() - t.savedAt > Nr ? null : {
			domain: t.domain,
			returnUrl: t.returnUrl
		};
	} catch {
		return null;
	}
}
function Lr(e) {
	return `/portal/login?${new URLSearchParams({
		domain: e.domain,
		returnUrl: e.returnUrl
	}).toString()}`;
}
//#endregion
//#region src/utils/oauthLinkResult.ts
var Rr = "teletienda.oauth.linkResult", zr = 60 * 1e3;
function Br(e) {
	let t = {
		result: e,
		savedAt: Date.now()
	};
	try {
		sessionStorage.setItem(Rr, JSON.stringify(t));
	} catch {}
}
function Vr() {
	try {
		let e = sessionStorage.getItem(Rr);
		if (sessionStorage.removeItem(Rr), !e) return null;
		let t = JSON.parse(e);
		if (typeof t?.savedAt != "number" || Date.now() - t.savedAt > zr) return null;
		let n = t.result;
		return !n || typeof n != "object" || typeof n.status != "string" || typeof n.provider != "string" ? null : n;
	} catch {
		return null;
	}
}
//#endregion
//#region src/components/AuthCallbackPage/AuthCallbackPage.tsx
function Hr({ provider: e, onSuccess: t, onError: n, onCancel: r, defaultReturnUrl: i = "/", linkReturnUrl: a = "/profile", loginUrl: o = "/login" }) {
	let { t: s } = R("auth"), [c, u] = f(null), [h, g] = f(!1), [_, y] = f(!0), b = X((e) => e.login), x = d(!1);
	l(() => {
		x.current || (x.current = !0, S());
	}, []);
	async function S() {
		try {
			let n = new URLSearchParams(window.location.search), a = n.get("code"), o = n.get("state"), c = n.get("error"), l = n.get("error_description");
			if (c === "access_denied") {
				g(!0), r?.();
				return;
			}
			if (c) throw Error(s("oauth.errors.provider_denied", { error: l || c }));
			if (!a) throw Error(s("oauth.errors.missing_code"));
			let u;
			switch (e) {
				case "google": {
					if (!o) throw Error(s("oauth.errors.missing_state"));
					let e = await nn(a, o);
					if (e.intent === "link") {
						w("google", e);
						return;
					}
					u = e;
					break;
				}
				case "telegram": {
					if (!o) throw Error(s("oauth.errors.missing_state"));
					let e = await sn(a, o);
					if (e.intent === "link") {
						w("telegram", e);
						return;
					}
					u = e;
					break;
				}
				case "facebook": throw Error(s("oauth.errors.facebook_no_redirect"));
				default: throw Error(s("oauth.errors.unknown_provider"));
			}
			let d = await Jt(u.accessToken), f = q({
				...d,
				user_guid: d.user_guid || u.user.guid,
				email: d.email || u.user.email || void 0
			});
			b(u.accessToken, u.refreshToken, u.expiresIn, f);
			let p = Ir(), m = u.returnUrl || (p ? Lr(p) : null) || i;
			t?.(m);
		} catch (e) {
			if (T(e)) {
				t?.(a);
				return;
			}
			let r = Hn(e, s);
			u(r), n?.(e instanceof Error ? e : Error(r));
		} finally {
			y(!1);
		}
	}
	function w(e, n) {
		Br({
			status: "linked",
			provider: e,
			alreadyLinked: n.alreadyLinked
		}), t?.(n.returnUrl || a);
	}
	function T(t) {
		let n = t;
		if (n?.status !== 409) return !1;
		let r = e, i = n.details?.merge_challenge;
		return n.code === "MERGE_AVAILABLE" && typeof i == "string" && i ? Br({
			status: "merge_available",
			provider: r,
			challenge: i
		}) : Br({
			status: "failed",
			provider: r,
			code: n.code ?? null
		}), !0;
	}
	return _ ? /* @__PURE__ */ B(v, {
		h: "100vh",
		children: /* @__PURE__ */ V(A, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ B(C, { size: "lg" }), /* @__PURE__ */ B(j, {
				c: "dimmed",
				children: s("oauth.processing")
			})]
		})
	}) : h ? /* @__PURE__ */ B(v, {
		h: "100vh",
		children: /* @__PURE__ */ B(p, {
			icon: /* @__PURE__ */ B(ue, { size: 16 }),
			title: s("oauth.cancelled_title"),
			color: "gray",
			variant: "light",
			maw: 400,
			children: s("oauth.cancelled")
		})
	}) : c ? /* @__PURE__ */ B(v, {
		h: "100vh",
		children: /* @__PURE__ */ B(p, {
			icon: /* @__PURE__ */ B(I, { size: 16 }),
			title: s("oauth.error_title"),
			color: "red",
			variant: "light",
			maw: 400,
			children: /* @__PURE__ */ V(A, {
				gap: "xs",
				align: "flex-start",
				children: [/* @__PURE__ */ B(j, {
					size: "sm",
					children: c
				}), /* @__PURE__ */ B(m, {
					href: o,
					size: "sm",
					children: s("oauth.back_to_login")
				})]
			})
		})
	}) : null;
}
//#endregion
//#region src/components/WhatsAppClaimLogin/WhatsAppClaimLogin.tsx
var Ur = 2e3;
function Wr({ merchantGuid: e, available: t, onAuthenticated: n, onError: r }) {
	let { t: i } = R("auth"), [a, o] = f("idle"), [c, u] = f(null), [m, h] = f(null), [g, v] = f(null), [y, x] = f(null), [C, w] = f(null), T = d(null), E = s(() => {
		T.current &&= (clearInterval(T.current), null);
	}, []);
	l(() => E, [E]);
	let D = s((e, t) => {
		E(), o("failed"), w(e), r?.(t instanceof Error ? t : Error(e));
	}, [r, E]), O = s((e, t) => {
		if (e === "confirmed") {
			E(), x(t), o("confirmed");
			return;
		}
		if (e === "expired") {
			D(i("claim.errors.expired", "El código venció. Probá de nuevo."));
			return;
		}
		e === "consumed" && D(i("claim.errors.used", "Este ingreso ya fue usado."));
	}, [
		D,
		E,
		i
	]), k = s(async () => {
		w(null), o("waiting");
		try {
			let t = await Xt(e);
			u(t.claim_guid), h(t.code), v(t.deep_link), E(), T.current = setInterval(async () => {
				try {
					let e = await Zt(t.claim_guid);
					O(e.status, e.masked_identity);
				} catch (e) {
					console.debug("[shared-auth-ui] channel-claim poll failed", e);
				}
			}, Ur);
		} catch (e) {
			D(e instanceof Z && e.code === "CHANNEL_CLAIM_UNAVAILABLE" ? i("claim.errors.unavailable", "Esta tienda no tiene WhatsApp disponible.") : i("claim.errors.start_failed", "No pudimos iniciar el ingreso por WhatsApp."), e);
		}
	}, [
		O,
		D,
		e,
		E,
		i
	]), M = s(async () => {
		if (c) {
			o("accepting");
			try {
				let e = await Qt(c);
				await n({
					accessToken: e.accessToken,
					refreshToken: e.refreshToken,
					expiresIn: e.expiresIn,
					userGuid: e.user.guid
				});
			} catch (e) {
				D(i("claim.errors.accept_failed", "No pudimos completar el ingreso."), e);
			}
		}
	}, [
		c,
		D,
		n,
		i
	]);
	return t ? a === "idle" ? /* @__PURE__ */ B(_, {
		leftSection: /* @__PURE__ */ B(oe, { size: 18 }),
		variant: "default",
		onClick: k,
		"data-testid": "whatsapp-claim-button",
		children: i("claim.button", "Ingresar con WhatsApp")
	}) : a === "failed" ? /* @__PURE__ */ V(A, {
		gap: "xs",
		children: [/* @__PURE__ */ B(p, {
			color: "red",
			"data-testid": "whatsapp-claim-error",
			children: C
		}), /* @__PURE__ */ B(_, {
			variant: "subtle",
			onClick: k,
			children: i("claim.retry", "Probar de nuevo")
		})]
	}) : a === "confirmed" || a === "accepting" ? /* @__PURE__ */ V(A, {
		gap: "sm",
		"data-testid": "whatsapp-claim-confirm",
		children: [
			/* @__PURE__ */ B(j, {
				size: "sm",
				children: i("claim.confirm_prompt", "Recibimos tu código desde este número:")
			}),
			/* @__PURE__ */ B(j, {
				fw: 700,
				size: "lg",
				"data-testid": "whatsapp-claim-mask",
				children: y
			}),
			/* @__PURE__ */ V(S, { children: [/* @__PURE__ */ B(_, {
				onClick: M,
				loading: a === "accepting",
				"data-testid": "whatsapp-claim-accept",
				children: i("claim.accept", "Sí, soy yo")
			}), /* @__PURE__ */ B(_, {
				variant: "subtle",
				onClick: () => {
					o("failed"), w(i("claim.errors.not_me", "Ingreso cancelado. No era tu número."));
				},
				children: i("claim.not_me", "No soy yo")
			})] })
		]
	}) : /* @__PURE__ */ V(A, {
		gap: "sm",
		"data-testid": "whatsapp-claim-waiting",
		children: [
			/* @__PURE__ */ B(j, {
				size: "sm",
				children: i("claim.waiting_prompt", "Enviános este código desde tu WhatsApp:")
			}),
			/* @__PURE__ */ B(b, {
				"data-testid": "whatsapp-claim-code",
				children: m
			}),
			g && /* @__PURE__ */ B(_, {
				component: "a",
				href: g,
				target: "_blank",
				rel: "noopener noreferrer",
				leftSection: /* @__PURE__ */ B(oe, { size: 18 }),
				"data-testid": "whatsapp-claim-deeplink",
				children: i("claim.open_whatsapp", "Abrir WhatsApp")
			}),
			/* @__PURE__ */ B(j, {
				size: "xs",
				c: "dimmed",
				children: i("claim.waiting_hint", "Esperando tu mensaje…")
			})
		]
	}) : null;
}
//#endregion
//#region src/utils/token.ts
function Gr(e) {
	try {
		let t = e.split(".");
		if (t.length !== 3) return null;
		let n = t[1], r = atob(n.replace(/-/g, "+").replace(/_/g, "/"));
		return JSON.parse(r);
	} catch {
		return null;
	}
}
function Kr(e) {
	let t = Gr(e);
	return t?.exp ? /* @__PURE__ */ new Date(t.exp * 1e3) : null;
}
function qr(e, t = 0) {
	let n = Kr(e);
	if (!n) return !0;
	let r = t * 1e3;
	return Date.now() >= n.getTime() - r;
}
function Jr(e) {
	return Gr(e)?.sub ?? null;
}
function Yr(e) {
	let t = Kr(e);
	if (!t) return 0;
	let n = t.getTime() - Date.now();
	return Math.max(0, Math.floor(n / 1e3));
}
var Xr = {
	login: {
		modal_title: "Iniciar sesión",
		page_title: "Iniciar sesión",
		page_subtitle: "Ingresa con tu cuenta",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Tu contraseña",
		submit: "Iniciar sesión",
		remember_me: "Recordarme",
		forgot_password: "¿Olvidaste tu contraseña?",
		no_account: "¿No tienes cuenta? Regístrate",
		error_title: "Error de autenticación",
		help_text: "¿Problemas para ingresar? Contacta al administrador.",
		success_title: "¡Bienvenido!",
		success_message: "Has iniciado sesión correctamente",
		or_with_email: "o con email",
		method_password: "Contraseña",
		method_code: "Código por email",
		send_code: "Enviar código de acceso",
		code: "Código de verificación",
		verify_and_sign_in: "Verificar e ingresar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado a tu email",
		errors: {
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			password_required: "La contraseña es requerida",
			invalid_credentials: "Correo o contraseña incorrectos",
			account_locked: "Tu cuenta está bloqueada. Contacta al administrador.",
			account_disabled: "Tu cuenta está deshabilitada",
			email_not_verified: "Por favor verifica tu correo electrónico",
			generic: "Ocurrió un error. Intenta de nuevo.",
			code_invalid: "El código debe tener 6 dígitos",
			code_send_failed: "Error al enviar el código. Intenta de nuevo.",
			code_expired: "Código expirado. Solicita uno nuevo.",
			code_rate_limited: "Demasiados intentos. Espera 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} intentos restantes."
		}
	},
	register: {
		modal_title: "Crear cuenta",
		page_title: "Registrarse",
		page_subtitle: "Crea tu cuenta",
		name_label: "Nombre completo",
		name_placeholder: "Juan Pérez",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar contraseña",
		confirm_password_placeholder: "Repite tu contraseña",
		terms_prefix: "Acepto los",
		terms_link: "Términos y Condiciones",
		terms_and: "y la",
		privacy_link: "Política de Privacidad",
		submit: "Crear cuenta",
		have_account: "¿Ya tienes cuenta? Inicia sesión",
		or_email: "o con email",
		error_title: "Error de registro",
		errors: {
			name_required: "El nombre es requerido",
			name_too_long: "El nombre es muy largo (máximo 100 caracteres)",
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			email_exists: "Ya existe una cuenta con este correo",
			password_min_length: "La contraseña debe tener al menos 8 caracteres",
			password_uppercase: "La contraseña debe contener al menos una mayúscula",
			password_lowercase: "La contraseña debe contener al menos una minúscula",
			password_number: "La contraseña debe contener al menos un número",
			confirm_password_required: "Confirma tu contraseña",
			passwords_mismatch: "Las contraseñas no coinciden",
			terms_required: "Debes aceptar los términos y condiciones",
			validation_error: "Error de validación. Revisa los campos.",
			rate_limited: "Demasiados intentos. Intenta más tarde.",
			generic: "Ocurrió un error. Intenta de nuevo."
		},
		verification: {
			title: "Verifica tu correo",
			message: "Hemos enviado un enlace de verificación a {{email}}. Por favor revisa tu bandeja de entrada.",
			resend_button: "Reenviar correo de verificación",
			resend_sent: "Correo enviado",
			resend_success: "Hemos reenviado el correo de verificación.",
			resend_error: "Error al reenviar. Intenta de nuevo.",
			back_to_login: "Volver a iniciar sesión"
		}
	},
	password: {
		strength: {
			label: "Fortaleza de contraseña",
			weak: "Débil",
			fair: "Regular",
			good: "Buena",
			strong: "Fuerte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Al menos una letra mayúscula",
			lowercase: "Al menos una letra minúscula",
			number: "Al menos un número"
		}
	},
	guard: {
		loading: "Verificando autenticación...",
		unauthorized_title: "Acceso Denegado",
		unauthorized_message: "No tienes permiso para acceder a esta página.",
		go_back: "Volver",
		go_home: "Ir al Inicio"
	},
	userMenu: {
		menuLabel: "Menú de usuario",
		profile: "Mi Perfil",
		orders: "Mis Pedidos",
		finances: "Mis Finanzas",
		logout: "Cerrar sesión",
		logoutConfirmTitle: "Cerrar sesión",
		logoutConfirmMessage: "¿Estás seguro de que quieres cerrar sesión?",
		cancel: "Cancelar",
		logout_success_title: "Sesión cerrada",
		logout_success_message: "Has cerrado sesión correctamente"
	},
	portal: {
		title: "Iniciar sesión en TeleTienda",
		register_title: "Crear cuenta TeleTienda",
		continue_to: "para continuar a {{domain}}",
		redirecting: "Redirigiendo a {{domain}}...",
		code_error: "Error al completar la autenticación. Por favor, inténtalo de nuevo."
	},
	oauth: {
		divider: "o continuar con",
		processing: "Iniciando sesión...",
		error_title: "Error de autenticación",
		google: {
			button: "Iniciar sesión con Google",
			signup_button: "Registrarse con Google"
		},
		facebook: {
			button: "Iniciar sesión con Facebook",
			signup_button: "Registrarse con Facebook"
		},
		telegram: {
			button: "Iniciar sesión con Telegram",
			signup_button: "Registrarse con Telegram"
		},
		errors: {
			provider_denied: "Acceso denegado: {{error}}",
			unknown_provider: "Proveedor de autenticación desconocido",
			missing_code: "Código de autorización faltante",
			popup_blocked: "La ventana emergente fue bloqueada. Permita ventanas emergentes e intente de nuevo.",
			network: "Error de red. Verifique su conexión.",
			generic: "Error de autenticación. Por favor, intente de nuevo.",
			missing_state: "Falta el parámetro de estado en el enlace de retorno",
			malformed_link: "El enlace de retorno está dañado. Iniciá sesión de nuevo.",
			session_expired: "La sesión de inicio expiró. Por favor, intentá iniciar sesión de nuevo.",
			rate_limited: "Demasiados intentos. Esperá un momento y volvé a intentar.",
			service_unavailable: "El servicio de inicio de sesión no está disponible temporalmente. No es un problema con tu cuenta.",
			facebook_no_redirect: "Facebook no soporta flujo de redirección"
		},
		cancelled_title: "Inicio de sesión cancelado",
		cancelled: "Cancelaste el inicio de sesión. Podés intentarlo de nuevo cuando quieras.",
		back_to_login: "Volver al inicio de sesión"
	},
	claim: {
		button: "Ingresar con WhatsApp",
		waiting_prompt: "Enviános este código desde tu WhatsApp:",
		open_whatsapp: "Abrir WhatsApp",
		waiting_hint: "Esperando tu mensaje…",
		confirm_prompt: "Recibimos tu código desde este número:",
		accept: "Sí, soy yo",
		not_me: "No soy yo",
		retry: "Probar de nuevo",
		errors: {
			start_failed: "No pudimos iniciar el ingreso por WhatsApp.",
			unavailable: "Esta tienda no tiene WhatsApp disponible.",
			expired: "El código venció. Probá de nuevo.",
			used: "Este ingreso ya fue usado.",
			accept_failed: "No pudimos completar el ingreso.",
			not_me: "Ingreso cancelado. No era tu número."
		}
	}
}, Zr = {
	login: {
		modal_title: "Sign in",
		page_title: "Sign in",
		page_subtitle: "Log in to your account",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Your password",
		submit: "Sign in",
		remember_me: "Remember me",
		forgot_password: "Forgot password?",
		no_account: "Don't have an account? Sign up",
		error_title: "Authentication error",
		help_text: "Having trouble signing in? Contact the administrator.",
		success_title: "Welcome!",
		success_message: "You have signed in successfully",
		or_with_email: "or with email",
		method_password: "Password",
		method_code: "Email Code",
		send_code: "Send login code",
		code: "Verification code",
		verify_and_sign_in: "Verify & Sign in",
		resend_code: "Resend code",
		code_sent: "Code sent to your email",
		errors: {
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			password_required: "Password is required",
			invalid_credentials: "Invalid email or password",
			account_locked: "Your account is locked. Contact the administrator.",
			account_disabled: "Your account is disabled",
			email_not_verified: "Please verify your email address",
			generic: "An error occurred. Please try again.",
			code_invalid: "Code must be 6 digits",
			code_send_failed: "Failed to send code. Please try again.",
			code_expired: "Code expired. Please request a new one.",
			code_rate_limited: "Too many attempts. Please wait 5 minutes.",
			code_invalid_value: "Invalid code. {{remaining}} attempts remaining."
		}
	},
	register: {
		modal_title: "Create account",
		page_title: "Sign up",
		page_subtitle: "Create your account",
		name_label: "Full name",
		name_placeholder: "John Doe",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Minimum 8 characters",
		confirm_password_label: "Confirm password",
		confirm_password_placeholder: "Repeat your password",
		terms_prefix: "I accept the",
		terms_link: "Terms and Conditions",
		terms_and: "and the",
		privacy_link: "Privacy Policy",
		submit: "Create account",
		have_account: "Already have an account? Sign in",
		or_email: "or with email",
		error_title: "Registration error",
		errors: {
			name_required: "Name is required",
			name_too_long: "Name is too long (maximum 100 characters)",
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			email_exists: "An account with this email already exists",
			password_min_length: "Password must be at least 8 characters",
			password_uppercase: "Password must contain at least one uppercase letter",
			password_lowercase: "Password must contain at least one lowercase letter",
			password_number: "Password must contain at least one number",
			confirm_password_required: "Please confirm your password",
			passwords_mismatch: "Passwords do not match",
			terms_required: "You must accept the terms and conditions",
			validation_error: "Validation error. Please check the fields.",
			rate_limited: "Too many attempts. Please try again later.",
			generic: "An error occurred. Please try again."
		},
		verification: {
			title: "Verify your email",
			message: "We've sent a verification link to {{email}}. Please check your inbox.",
			resend_button: "Resend verification email",
			resend_sent: "Email sent",
			resend_success: "We've resent the verification email.",
			resend_error: "Failed to resend. Please try again.",
			back_to_login: "Back to sign in"
		}
	},
	password: {
		strength: {
			label: "Password strength",
			weak: "Weak",
			fair: "Fair",
			good: "Good",
			strong: "Strong"
		},
		requirements: {
			length: "Minimum 8 characters",
			uppercase: "At least one uppercase letter",
			lowercase: "At least one lowercase letter",
			number: "At least one number"
		}
	},
	guard: {
		loading: "Checking authentication...",
		unauthorized_title: "Access Denied",
		unauthorized_message: "You don't have permission to access this page.",
		go_back: "Go Back",
		go_home: "Go Home"
	},
	userMenu: {
		menuLabel: "User menu",
		profile: "My Profile",
		orders: "My Orders",
		finances: "My Finances",
		logout: "Log out",
		logoutConfirmTitle: "Log out",
		logoutConfirmMessage: "Are you sure you want to log out?",
		cancel: "Cancel",
		logout_success_title: "Logged out",
		logout_success_message: "You have logged out successfully"
	},
	portal: {
		title: "Sign in to TeleTienda",
		register_title: "Create TeleTienda Account",
		continue_to: "to continue to {{domain}}",
		redirecting: "Redirecting to {{domain}}...",
		code_error: "Failed to complete authentication. Please try again."
	},
	oauth: {
		divider: "or continue with",
		processing: "Signing you in...",
		error_title: "Authentication Failed",
		google: {
			button: "Sign in with Google",
			signup_button: "Sign up with Google"
		},
		facebook: {
			button: "Sign in with Facebook",
			signup_button: "Sign up with Facebook"
		},
		telegram: {
			button: "Log in with Telegram",
			signup_button: "Sign up with Telegram"
		},
		errors: {
			provider_denied: "Access was denied by {{error}}",
			unknown_provider: "Unknown authentication provider",
			missing_code: "Missing authorization code",
			popup_blocked: "Popup was blocked. Please allow popups and try again.",
			network: "Network error. Please check your connection.",
			generic: "Authentication failed. Please try again.",
			missing_state: "The return link is missing its state parameter",
			malformed_link: "The return link is damaged. Please sign in again.",
			session_expired: "Your sign-in session expired. Please try signing in again.",
			rate_limited: "Too many attempts. Please wait a moment and try again.",
			service_unavailable: "The sign-in service is temporarily unavailable. This is not a problem with your account.",
			facebook_no_redirect: "Facebook does not support the redirect flow"
		},
		cancelled_title: "Sign-in cancelled",
		cancelled: "You cancelled the sign-in. You can try again whenever you like.",
		back_to_login: "Back to sign in"
	},
	claim: {
		button: "Log in with WhatsApp",
		waiting_prompt: "Send us this code from your WhatsApp:",
		open_whatsapp: "Open WhatsApp",
		waiting_hint: "Waiting for your message…",
		confirm_prompt: "We received your code from this number:",
		accept: "Yes, that's me",
		not_me: "That's not me",
		retry: "Try again",
		errors: {
			start_failed: "We could not start the WhatsApp login.",
			unavailable: "This store has no WhatsApp available.",
			expired: "The code expired. Please try again.",
			used: "This login has already been used.",
			accept_failed: "We could not complete the login.",
			not_me: "Login cancelled. That was not your number."
		}
	}
}, Qr = {
	login: {
		modal_title: "Вход",
		page_title: "Вход в систему",
		page_subtitle: "Войдите в свой аккаунт",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Ваш пароль",
		submit: "Войти",
		remember_me: "Запомнить меня",
		forgot_password: "Забыли пароль?",
		no_account: "Нет аккаунта? Зарегистрируйтесь",
		error_title: "Ошибка авторизации",
		help_text: "Проблемы со входом? Свяжитесь с администратором.",
		success_title: "Добро пожаловать!",
		success_message: "Вы успешно вошли в систему",
		or_with_email: "или по email",
		method_password: "Пароль",
		method_code: "Код на email",
		send_code: "Отправить код входа",
		code: "Код подтверждения",
		verify_and_sign_in: "Подтвердить и войти",
		resend_code: "Отправить код ещё раз",
		code_sent: "Код отправлен на ваш email",
		errors: {
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			password_required: "Пароль обязателен",
			invalid_credentials: "Неверный email или пароль",
			account_locked: "Ваш аккаунт заблокирован. Свяжитесь с администратором.",
			account_disabled: "Ваш аккаунт отключен",
			email_not_verified: "Пожалуйста, подтвердите ваш email",
			generic: "Произошла ошибка. Попробуйте снова.",
			code_invalid: "Код должен содержать 6 цифр",
			code_send_failed: "Не удалось отправить код. Попробуйте снова.",
			code_expired: "Код истёк. Запросите новый.",
			code_rate_limited: "Слишком много попыток. Подождите 5 минут.",
			code_invalid_value: "Неверный код. Осталось попыток: {{remaining}}."
		}
	},
	register: {
		modal_title: "Создать аккаунт",
		page_title: "Регистрация",
		page_subtitle: "Создайте свой аккаунт",
		name_label: "Полное имя",
		name_placeholder: "Иван Иванов",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Минимум 8 символов",
		confirm_password_label: "Подтвердите пароль",
		confirm_password_placeholder: "Повторите пароль",
		terms_prefix: "Я принимаю",
		terms_link: "Условия использования",
		terms_and: "и",
		privacy_link: "Политику конфиденциальности",
		submit: "Создать аккаунт",
		have_account: "Уже есть аккаунт? Войти",
		or_email: "или по email",
		error_title: "Ошибка регистрации",
		errors: {
			name_required: "Имя обязательно",
			name_too_long: "Имя слишком длинное (максимум 100 символов)",
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			email_exists: "Аккаунт с таким email уже существует",
			password_min_length: "Пароль должен содержать минимум 8 символов",
			password_uppercase: "Пароль должен содержать хотя бы одну заглавную букву",
			password_lowercase: "Пароль должен содержать хотя бы одну строчную букву",
			password_number: "Пароль должен содержать хотя бы одну цифру",
			confirm_password_required: "Подтвердите пароль",
			passwords_mismatch: "Пароли не совпадают",
			terms_required: "Вы должны принять условия использования",
			validation_error: "Ошибка валидации. Проверьте поля.",
			rate_limited: "Слишком много попыток. Попробуйте позже.",
			generic: "Произошла ошибка. Попробуйте снова."
		},
		verification: {
			title: "Подтвердите email",
			message: "Мы отправили ссылку для подтверждения на {{email}}. Проверьте вашу почту.",
			resend_button: "Отправить письмо повторно",
			resend_sent: "Письмо отправлено",
			resend_success: "Мы повторно отправили письмо для подтверждения.",
			resend_error: "Не удалось отправить. Попробуйте снова.",
			back_to_login: "Вернуться к входу"
		}
	},
	password: {
		strength: {
			label: "Надежность пароля",
			weak: "Слабый",
			fair: "Средний",
			good: "Хороший",
			strong: "Надежный"
		},
		requirements: {
			length: "Минимум 8 символов",
			uppercase: "Хотя бы одна заглавная буква",
			lowercase: "Хотя бы одна строчная буква",
			number: "Хотя бы одна цифра"
		}
	},
	guard: {
		loading: "Проверка аутентификации...",
		unauthorized_title: "Доступ Запрещен",
		unauthorized_message: "У вас нет прав для доступа к этой странице.",
		go_back: "Назад",
		go_home: "На Главную"
	},
	userMenu: {
		menuLabel: "Меню пользователя",
		profile: "Мой Профиль",
		orders: "Мои Заказы",
		finances: "Мои Финансы",
		logout: "Выйти",
		logoutConfirmTitle: "Выход из системы",
		logoutConfirmMessage: "Вы уверены, что хотите выйти?",
		cancel: "Отмена",
		logout_success_title: "Вы вышли",
		logout_success_message: "Вы успешно вышли из системы"
	},
	portal: {
		title: "Вход в TeleTienda",
		register_title: "Создать аккаунт TeleTienda",
		continue_to: "для продолжения на {{domain}}",
		redirecting: "Перенаправление на {{domain}}...",
		code_error: "Не удалось завершить авторизацию. Пожалуйста, попробуйте снова."
	},
	oauth: {
		divider: "или продолжить через",
		processing: "Выполняется вход...",
		error_title: "Ошибка аутентификации",
		google: {
			button: "Войти через Google",
			signup_button: "Зарегистрироваться через Google"
		},
		facebook: {
			button: "Войти через Facebook",
			signup_button: "Зарегистрироваться через Facebook"
		},
		telegram: {
			button: "Войти через Telegram",
			signup_button: "Зарегистрироваться через Telegram"
		},
		errors: {
			provider_denied: "Доступ запрещен: {{error}}",
			unknown_provider: "Неизвестный провайдер аутентификации",
			missing_code: "Отсутствует код авторизации",
			popup_blocked: "Всплывающее окно заблокировано. Разрешите всплывающие окна и попробуйте снова.",
			network: "Ошибка сети. Проверьте подключение.",
			generic: "Ошибка аутентификации. Попробуйте снова.",
			missing_state: "В ссылке возврата отсутствует параметр state",
			malformed_link: "Ссылка возврата повреждена. Войдите заново.",
			session_expired: "Сессия входа истекла. Пожалуйста, попробуйте войти ещё раз.",
			rate_limited: "Слишком много попыток. Подождите немного и попробуйте снова.",
			service_unavailable: "Сервис входа временно недоступен. Это не проблема с вашим аккаунтом.",
			facebook_no_redirect: "Facebook не поддерживает redirect-флоу"
		},
		cancelled_title: "Вход отменён",
		cancelled: "Вы отменили вход. Можно попробовать снова в любой момент.",
		back_to_login: "Вернуться к входу"
	},
	claim: {
		button: "Войти через WhatsApp",
		waiting_prompt: "Отправьте нам этот код со своего WhatsApp:",
		open_whatsapp: "Открыть WhatsApp",
		waiting_hint: "Ждём ваше сообщение…",
		confirm_prompt: "Мы получили ваш код с этого номера:",
		accept: "Да, это я",
		not_me: "Это не я",
		retry: "Попробовать снова",
		errors: {
			start_failed: "Не удалось начать вход через WhatsApp.",
			unavailable: "У этого магазина нет WhatsApp.",
			expired: "Код истёк. Попробуйте снова.",
			used: "Этот вход уже использован.",
			accept_failed: "Не удалось завершить вход.",
			not_me: "Вход отменён. Это был не ваш номер."
		}
	}
}, $r = {
	login: {
		modal_title: "Entrar",
		page_title: "Entrar",
		page_subtitle: "Acesse sua conta",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Sua senha",
		submit: "Entrar",
		remember_me: "Lembrar-me",
		forgot_password: "Esqueceu a senha?",
		no_account: "Não tem conta? Cadastre-se",
		error_title: "Erro de autenticação",
		help_text: "Problemas para entrar? Entre em contato com o administrador.",
		success_title: "Bem-vindo!",
		success_message: "Você entrou com sucesso",
		or_with_email: "ou com e-mail",
		method_password: "Senha",
		method_code: "Código por e-mail",
		send_code: "Enviar código de acesso",
		code: "Código de verificação",
		verify_and_sign_in: "Verificar e entrar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado para seu e-mail",
		errors: {
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			password_required: "A senha é obrigatória",
			invalid_credentials: "E-mail ou senha incorretos",
			account_locked: "Sua conta está bloqueada. Entre em contato com o administrador.",
			account_disabled: "Sua conta está desativada",
			email_not_verified: "Por favor, verifique seu e-mail",
			generic: "Ocorreu um erro. Tente novamente.",
			code_invalid: "O código deve ter 6 dígitos",
			code_send_failed: "Erro ao enviar o código. Tente novamente.",
			code_expired: "Código expirado. Solicite um novo.",
			code_rate_limited: "Muitas tentativas. Aguarde 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} tentativas restantes."
		}
	},
	register: {
		modal_title: "Criar conta",
		page_title: "Cadastrar",
		page_subtitle: "Crie sua conta",
		name_label: "Nome completo",
		name_placeholder: "João Silva",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar senha",
		confirm_password_placeholder: "Repita sua senha",
		terms_prefix: "Eu aceito os",
		terms_link: "Termos e Condições",
		terms_and: "e a",
		privacy_link: "Política de Privacidade",
		submit: "Criar conta",
		have_account: "Já tem uma conta? Entrar",
		or_email: "ou com e-mail",
		error_title: "Erro de cadastro",
		errors: {
			name_required: "O nome é obrigatório",
			name_too_long: "O nome é muito longo (máximo 100 caracteres)",
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			email_exists: "Já existe uma conta com este e-mail",
			password_min_length: "A senha deve ter pelo menos 8 caracteres",
			password_uppercase: "A senha deve conter pelo menos uma letra maiúscula",
			password_lowercase: "A senha deve conter pelo menos uma letra minúscula",
			password_number: "A senha deve conter pelo menos um número",
			confirm_password_required: "Por favor, confirme sua senha",
			passwords_mismatch: "As senhas não coincidem",
			terms_required: "Você deve aceitar os termos e condições",
			validation_error: "Erro de validação. Verifique os campos.",
			rate_limited: "Muitas tentativas. Tente novamente mais tarde.",
			generic: "Ocorreu um erro. Tente novamente."
		},
		verification: {
			title: "Verifique seu e-mail",
			message: "Enviamos um link de verificação para {{email}}. Por favor, verifique sua caixa de entrada.",
			resend_button: "Reenviar e-mail de verificação",
			resend_sent: "E-mail enviado",
			resend_success: "Reenviamos o e-mail de verificação.",
			resend_error: "Falha ao reenviar. Tente novamente.",
			back_to_login: "Voltar para entrar"
		}
	},
	password: {
		strength: {
			label: "Força da senha",
			weak: "Fraca",
			fair: "Regular",
			good: "Boa",
			strong: "Forte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Pelo menos uma letra maiúscula",
			lowercase: "Pelo menos uma letra minúscula",
			number: "Pelo menos um número"
		}
	},
	guard: {
		loading: "Verificando autenticação...",
		unauthorized_title: "Acesso Negado",
		unauthorized_message: "Você não tem permissão para acessar esta página.",
		go_back: "Voltar",
		go_home: "Ir para Início"
	},
	userMenu: {
		menuLabel: "Menu do usuário",
		profile: "Meu Perfil",
		orders: "Meus Pedidos",
		finances: "Minhas Finanças",
		logout: "Sair",
		logoutConfirmTitle: "Sair",
		logoutConfirmMessage: "Tem certeza de que deseja sair?",
		cancel: "Cancelar",
		logout_success_title: "Sessão encerrada",
		logout_success_message: "Você saiu com sucesso"
	},
	portal: {
		title: "Entrar na TeleTienda",
		register_title: "Criar conta TeleTienda",
		continue_to: "para continuar em {{domain}}",
		redirecting: "Redirecionando para {{domain}}...",
		code_error: "Falha ao completar a autenticação. Por favor, tente novamente."
	},
	oauth: {
		divider: "ou continuar com",
		processing: "Entrando...",
		error_title: "Falha na autenticação",
		google: {
			button: "Entrar com Google",
			signup_button: "Cadastrar com Google"
		},
		facebook: {
			button: "Entrar com Facebook",
			signup_button: "Cadastrar com Facebook"
		},
		telegram: {
			button: "Entrar com Telegram",
			signup_button: "Cadastrar com Telegram"
		},
		errors: {
			provider_denied: "Acesso negado: {{error}}",
			unknown_provider: "Provedor de autenticação desconhecido",
			missing_code: "Código de autorização ausente",
			popup_blocked: "A janela pop-up foi bloqueada. Permita pop-ups e tente novamente.",
			network: "Erro de rede. Verifique sua conexão.",
			generic: "Falha na autenticação. Tente novamente.",
			missing_state: "Falta o parâmetro de estado no link de retorno",
			malformed_link: "O link de retorno está danificado. Faça login novamente.",
			session_expired: "A sessão de login expirou. Por favor, tente entrar novamente.",
			rate_limited: "Muitas tentativas. Aguarde um momento e tente novamente.",
			service_unavailable: "O serviço de login está temporariamente indisponível. Não é um problema com sua conta.",
			facebook_no_redirect: "O Facebook não suporta o fluxo de redirecionamento"
		},
		cancelled_title: "Login cancelado",
		cancelled: "Você cancelou o login. Pode tentar novamente quando quiser.",
		back_to_login: "Voltar ao login"
	},
	claim: {
		button: "Entrar com WhatsApp",
		waiting_prompt: "Envie este código pelo seu WhatsApp:",
		open_whatsapp: "Abrir WhatsApp",
		waiting_hint: "Aguardando sua mensagem…",
		confirm_prompt: "Recebemos seu código deste número:",
		accept: "Sim, sou eu",
		not_me: "Não sou eu",
		retry: "Tentar novamente",
		errors: {
			start_failed: "Não foi possível iniciar o login pelo WhatsApp.",
			unavailable: "Esta loja não tem WhatsApp disponível.",
			expired: "O código expirou. Tente novamente.",
			used: "Este login já foi usado.",
			accept_failed: "Não foi possível concluir o login.",
			not_me: "Login cancelado. Não era o seu número."
		}
	}
}, ei = [
	"es",
	"en",
	"ru",
	"pt"
], ti = "es", ni = {
	es: { auth: Xr },
	en: { auth: Zr },
	ru: { auth: Qr },
	pt: { auth: $r }
};
function ri(e) {
	return ni[e];
}
function ii(e) {
	for (let t of ei) e.addResourceBundle(t, "auth", ni[t].auth, !0, !1);
}
//#endregion
export { Tt as AUTH_STORAGE_NAME, Z as AuthApiError, Hr as AuthCallbackPage, wr as AuthGuard, jr as AuthProvider, Ee as COOKIE_MAX_AGE, at as COOKIE_MAX_SIZE, it as COOKIE_WARNING_THRESHOLD, we as CROSS_SUBDOMAIN_SYNC_COOKIE, Te as CROSS_SUBDOMAIN_SYNC_INTERVAL, ti as DEFAULT_LANGUAGE, Gn as FacebookLoginButton, Wn as GoogleLoginButton, hr as LoadingFallback, Qn as LoginForm, tr as LoginModal, nr as LoginPage, Rr as OAUTH_LINK_RESULT_KEY, e as PLATFORM_ADMIN_ROLES, Mr as PORTAL_OAUTH_CONTEXT_KEY, De as PRODUCTION_DOMAIN, cr as PasswordStrengthIndicator, Tr as ProtectedRoute, gr as RETURN_URL_PARAM, ur as RegisterForm, fr as RegisterModal, rt as SLIM_AUTH_COOKIE_NAME, Se as STORAGE_KEY, ei as SUPPORTED_LANGUAGES, Ce as SYNC_CHANNEL_NAME, Yn as SocialLoginButtons, Jn as TelegramLoginButton, mr as UnauthorizedFallback, Er as UserAvatar, Or as UserMenu, dr as VerificationSuccess, Wr as WhatsAppClaimLogin, Qt as acceptChannelClaimApi, ii as addAuthTranslations, Re as areCookiesEnabled, vn as authFetch, ni as authTranslations, et as broadcastCrossSubdomainLogin, tt as broadcastCrossSubdomainLogout, nt as broadcastCrossSubdomainTokenRefresh, Ke as broadcastLogin, qe as broadcastLogout, Je as broadcastTokenRefresh, yr as buildRedirectUrl, ir as calculatePasswordStrength, rr as checkPasswordRequirements, ht as checkStorageHealth, zt as clearAuthStorage, Fr as clearPortalOAuthContext, ft as configureAuthApi, gn as configureHttpClient, Vr as consumeOAuthLinkResult, Ir as consumePortalOAuthContext, kt as createAuthStoreSlice, pn as createAuthenticatedClient, wt as createZustandStorage, Gr as decodeToken, Le as deleteCookie, W as deleteSlimCookie, Hn as describeOAuthError, rn as facebookOAuthCallbackApi, Jt as fetchUserProfileApi, K as getApiClient, pt as getApiConfig, J as getAuthStorage, ri as getAuthTranslations, Zt as getChannelClaimApi, Fe as getCookie, Be as getCookieJSON, ct as getCookieSizeInfo, Ze as getCrossSubdomainSync, Ue as getCrossTabSync, xr as getCurrentPath, _n as getHttpClient, Tn as getRefreshPromise, br as getReturnUrl, U as getSlimCookie, H as getStorageConfig, Bt as getStorageHealth, ar as getStrengthColor, or as getStrengthLabel, Kr as getTokenExpiration, Yr as getTokenTTL, Jr as getUserGuidFromToken, $t as googleOAuthCallbackApi, nn as googleOidcCallbackApi, yt as hasFullUserData, vt as hydrateFromApi, It as initAuthSync, bt as isHydrationNeeded, gt as isPrivateBrowsing, Cr as isRedirectLoop, ot as isSlimAuthData, Rt as isTokenExpired, qr as isTokenExpiredFromString, vr as isValidReturnUrl, Ht as loginApi, qt as loginByCodeApi, Xn as loginSchema, Gt as logoutApi, Lt as needsTokenRefresh, Ge as onAuthSync, $e as onCrossSubdomainSync, Pe as parseCookies, Sr as performRedirect, Lr as portalReturnPath, Wt as refreshTokenApi, Ut as registerApi, lr as registerSchema, Kt as requestLoginCodeApi, Ct as resetAuthStorage, Qe as resetCrossSubdomainSync, We as resetCrossTabSync, un as resetHttpClientState, En as resetRefreshPromise, Ne as resetStorageConfig, Ft as retryInitialHydration, Br as saveOAuthLinkResult, Pr as savePortalOAuthContext, Ie as setCookie, ze as setCookieJSON, lt as setSlimCookie, Dt as setStorageAdapter, Me as setStorageConfig, mt as setTokenGetter, Xt as startChannelClaimApi, tn as startGoogleLinkOidcApi, en as startGoogleOidcApi, on as startTelegramLinkOidcApi, an as startTelegramOidcApi, sn as telegramOidcCallbackApi, q as transformApiUser, yn as useAuth, Ar as useAuthContext, xn as useAuthGuard, X as useAuthStore, On as useFacebookAuth, bn as useHasHydrated, Dn as useTokenRefresh };

//# sourceMappingURL=index.es.js.map